import { logoutApi } from './api';
import axios from 'axios';
import InvoiceAddressForm from './InvoiceAddressForm';
import OrderHistory from "./OrderHistory";
// Hilfsfunktion zur E-Mail-Validierung
function isValidEmail(email) {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
}
import Login from "./Login";
import BurgerMenu from './BurgerMenu';

// Maximale Bildgröße für Logo-Upload (z.B. 2000x2000 Pixel)

const PORTAL_NAME = 'Schwarzwald-Meldeschein';


// Tooltip-Komponente für wiederverwendbare Tooltips
function Tooltip({ text, children, position = 'top', minWidth = '70px', className = '' }) {
  const [visible, setVisible] = React.useState(false);
  // Tooltip-Positionierung
  let tooltipStyle = {
    transition: 'opacity 0.2s',
    opacity: visible ? 1 : 0,
    pointerEvents: 'none',
    position: 'absolute',
    left: '50%',
    background: '#222',
    color: '#fff',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    zIndex: 20,
    minWidth,
    textAlign: 'center',
  };
  if (position === 'top') {
    tooltipStyle.bottom = '110%';
    tooltipStyle.transform = 'translateX(-50%) translateY(100%)';
  } else if (position === 'bottom') {
    tooltipStyle.top = '110%';
    tooltipStyle.transform = 'translateX(-50%)';
  } else if (position === 'left') {
    tooltipStyle.right = '110%';
    tooltipStyle.top = '50%';
    tooltipStyle.transform = 'translateY(-50%)';
  } else if (position === 'right') {
    tooltipStyle.left = '110%';
    tooltipStyle.top = '50%';
    tooltipStyle.transform = 'translateY(-100%)';
  }
  // Multiline support: if text contains '\n', render as lines
  let tooltipContent;
  if (typeof text === 'string' && text.includes('\n')) {
    const [headline, ...lines] = text.split('\n');
    tooltipContent = (
      <div>
        <div>{headline}</div>
        <ul className="text-left mt-1" style={{ paddingLeft: 0, margin: 0, listStyle: 'none' }}>
          {lines.map((line, i) =>
            line.trim() && (
              <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ fontWeight: 'bold', fontSize: '1.1em', marginRight: 6 }}>&bull;</span>
                <span>{line.replace(/^[-•]\s*/, '')}</span>
              </li>
            )
          )}
        </ul>
      </div>
    );
  } else {
    tooltipContent = text;
  }
  return (
    <span
      className={`relative inline-block ${className ? className : ''}`}
      style={className && className.includes('w-full') ? { display: 'block', width: '100%' } : {}}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      tabIndex={-1}
    >
      {children}
      <span style={tooltipStyle}>{tooltipContent}</span>
    </span>
  );
}

// Startseite Komponente
function Startseite({ onStartOrder, typewriterPlayed, setTypewriterPlayed, begruessung }) {
  const [fmResult, setFmResult] = React.useState(null);
  const [fmLoading, setFmLoading] = React.useState(false);
  // Typewriter-Effekt State
  const [typedGreeting, setTypedGreeting] = React.useState('');
  // const [debugApiResponse, setDebugApiResponse] = React.useState(null);
  React.useEffect(() => {
    if (!begruessung) {
      setTypedGreeting('');
      return;
    }
    if (typewriterPlayed) {
      setTypedGreeting(begruessung);
      return;
    }
    setTypedGreeting('');
    let idx = 0;
    let acc = '';
    const chars = begruessung;
    let cancelled = false;
    function typeNext() {
      if (cancelled) return;
      if (idx < chars.length) {
        acc += chars[idx];
        setTypedGreeting(acc);
        idx++;
        setTimeout(typeNext, chars[idx - 1] === '\n' ? 100 : 18);
      } else {
        setTypewriterPlayed(false);
        window.sessionStorage.setItem('typewriterPlayed', 'false');
      }
    }
    setTimeout(typeNext, 100);
    return () => { cancelled = true; };
  }, [begruessung, typewriterPlayed, setTypewriterPlayed]);

  // Temporärer State für Script-Parameter
  const [scriptParam1, setScriptParam1] = React.useState('');
  const [scriptParam2, setScriptParam2] = React.useState('');
  const [scriptLoading, setScriptLoading] = React.useState(false);
  const [scriptResult, setScriptResult] = React.useState(null);
  const handleScriptCall = async () => {
    setScriptLoading(true);
    setScriptResult(null);
    try {
      const { callFilemakerScript } = await import('./filemaker');
      // Kombiniere beide Parameter als JSON-String
      const paramObj = { param1: scriptParam1, param2: scriptParam2 };
      const paramString = JSON.stringify(paramObj);
      const result = await callFilemakerScript('GMK_duplizieren_STG', paramString);
      // const result = await callFilemakerScript('APITestScript', paramString);
      setScriptResult(result);
    } catch (e) {
      setScriptResult({ error: e.message });
    }
    setScriptLoading(false);
  };
  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ scrollbarGutter: 'stable' }}>
      <div className="bg-white rounded-2xl shadow-xl p-8 flex flex-col items-center">
        <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '64px', width: 'auto' }} className="mb-6" />
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Willkommen im {PORTAL_NAME} Bestellportal</h1>
        <p className="text-gray-600 mb-4 mt-2 text-center max-w-xl" style={{ minHeight: 48 }}>
          {typedGreeting
            ? typedGreeting.split('\n').map((line, idx, arr) =>
              idx < arr.length - 1 ? (
                <React.Fragment key={idx}>
                  {line}<br />
                </React.Fragment>
              ) : (
                <React.Fragment key={idx}>{line}</React.Fragment>
              )
            )
            : null}
        </p>
        <p className="text-gray-600 mb-8 text-center max-w-xl">
          Hier können Sie Ihre individuellen Gästekarten und Meldescheine bestellen. Klicken Sie auf den Button, um Ihre Bestellung zu starten.
        </p>
        <button
          onClick={onStartOrder}
          className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-xl shadow mb-4"
        >
          Bestellung starten
        </button>
        {/* Temporärer FileMaker-Script-Button ... */}
      </div>
    </div>
  );
}
// ProductCard Komponente
function ProductCard({ product, onSelect, isSelected, disabled, onImageClick }) {
  return (
    <div
      className={`bg-white rounded-lg shadow-md p-4 border transition-all duration-200 relative ${isSelected ? 'border-blue-500 ring-2 ring-blue-300' : 'border-gray-200'} ${disabled ? 'opacity-60 pointer-events-none' : 'hover:border-blue-400 hover:shadow-lg'}`}
      onClick={() => !disabled && onSelect && onSelect(product)}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer', minHeight: 220, paddingBottom: 56 }}
    >
      {product.image_url && (
        <img
          src={product.image_url}
          alt={product.name}
          className="h-20 w-auto mb-3 mx-auto rounded cursor-zoom-in"
          style={{ maxWidth: '120px' }}
          onClick={e => {
            e.stopPropagation();
            if (onImageClick) onImageClick(product.image_url, product.name);
          }}
        />
      )}
      <h3 className="text-lg font-bold text-gray-800 mb-2 break-words">{product.name}</h3>
      <p className="text-sm text-gray-600 mb-2 break-words">{product.description}</p>
      {/* Preis/Menge immer bündig unten, mit zusätzlichem Platz durch paddingBottom */}
      <div className="absolute left-0 bottom-0 w-full px-4 pb-4 flex justify-between items-end pointer-events-none">
        <div className="flex flex-col items-start">
          {product.base_price_quantity && product.base_price && (
            <span className="text-xs text-gray-500 mt-1">Preis pro {product.base_price_quantity.toLocaleString('de-DE')} Stück</span>
          )}
          <span className="text-xs text-gray-500">Mindestmenge: {product.min_quantity?.toLocaleString('de-DE') || 500}</span>
          {product.step_quantity && (
            <span className="text-xs text-gray-500 mt-1">Schrittweite: {product.step_quantity.toLocaleString('de-DE')}</span>
          )}
        </div>
        <span className="font-semibold text-green-700">{formatEuro(product.base_price)}</span>
      </div>
      {disabled && (
        <div className="mt-2 text-xs text-gray-400">Bereits im Warenkorb</div>
      )}
    </div>
  );
}


// function ProductCard({ product, onSelect, isSelected, disabled }) {
//   const [modalImg, setModalImg] = React.useState(null);
//   return (
//     <div
//       className={`bg-white rounded-lg shadow-md p-4 border transition-all duration-200 relative ${isSelected ? 'border-blue-500 ring-2 ring-blue-300' : 'border-gray-200'} ${disabled ? 'opacity-60 pointer-events-none' : 'hover:border-blue-400 hover:shadow-lg'}`}
//       onClick={() => !disabled && onSelect && onSelect(product)}
//       style={{ cursor: disabled ? 'not-allowed' : 'pointer', minHeight: 220, paddingBottom: 56 }}
//     >
//       {product.image_url && (
//         <img src={product.image_url} alt={product.name} className="h-20 w-auto mb-3 mx-auto rounded" style={{ maxWidth: '120px' }}                   onClick={e => {
//                     e.stopPropagation();
//                     setModalImg(product.image_url);
//                   }} />
//       )}
//       <h3 className="text-lg font-bold text-gray-800 mb-2 break-words">{product.name}</h3>
//       <p className="text-sm text-gray-600 mb-2 break-words">{product.description}</p>
//       {/* Preis/Menge immer bündig unten, mit zusätzlichem Platz durch paddingBottom */}
//       <div className="absolute left-0 bottom-0 w-full px-4 pb-4 flex justify-between items-end pointer-events-none">
//         <div className="flex flex-col items-start">
//           {product.base_price_quantity && product.base_price && (
//             <span className="text-xs text-gray-500 mt-1">Preis pro {product.base_price_quantity.toLocaleString('de-DE')} Stück</span>
//           )}
//           <span className="text-xs text-gray-500">Mindestmenge: {product.min_quantity?.toLocaleString('de-DE') || 500}</span>
//           {product.step_quantity && (
//             <span className="text-xs text-gray-500 mt-1">Schrittweite: {product.step_quantity.toLocaleString('de-DE')}</span>
//           )}
//         </div>
//         <span className="font-semibold text-green-700">{formatEuro(product.base_price)}</span>
//       </div>
//       {disabled && (
//         <div className="mt-2 text-xs text-gray-400">Bereits im Warenkorb</div>
//       )}
//     </div>
//   );
// }

// AddressForm Komponente
function AddressForm({ address, onChange, customerEmail, onEmailChange }) {
  // Automatische Synchronisation mit FileMaker
  const { useRef } = React;
  const debounceTimer = useRef();
  const lastValues = useRef({ ...address, email: customerEmail });
  React.useEffect(() => {
    // Nur senden, wenn sich Werte geändert haben
    if (JSON.stringify(lastValues.current) !== JSON.stringify({ ...address, email: customerEmail })) {
      lastValues.current = { ...address, email: customerEmail };
      // Debounce: 500ms nach letzter Änderung
      clearTimeout(debounceTimer.current);
      debounceTimer.current = setTimeout(() => {
        // console.log('[updateCustomerInfo] Sende:', {
        //   institution: address.institution,
        //   adresszusatz: address.adresszusatz,
        //   name: address.name,
        //   street: address.street,
        //   city: address.city,
        //   postal_code: address.postal_code,
        //   email: customerEmail,
        //   recid: address.recid
        // });
        import('./api').then(api => {
          const token = window.sessionStorage.getItem('token');
          api.updateCustomerInfo({
            institution: address.institution,
            adresszusatz: address.adresszusatz,
            name: address.name,
            street: address.street,
            city: address.city,
            postal_code: address.postal_code,
            recid: address.recid,
            token
          }).catch(() => { });
        });
      }, 500);
    }
    return () => clearTimeout(debounceTimer.current);
  }, [address, customerEmail]);
  // ...Form wie gehabt...
  return (
    <div className="bg-white p-6 rounded-xl shadow-md mb-2">
      <h4 className="font-semibold text-gray-800 mb-3">Lieferadresse</h4>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Firmenname Zeile 1</label>
          <input
            type="text"
            value={address.institution || ''}
            onChange={e => onChange({ ...address, institution: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Firmenname Zeile 1 (optional)"
            maxLength={60}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Firmenname Zeile 2</label>
          <input
            type="text"
            value={address.adresszusatz || ''}
            onChange={e => onChange({ ...address, adresszusatz: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Firmenname Zeile 2 (Adresszusatz, optional)"
            maxLength={60}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Empfänger</label>
          <input
            type="text"
            value={address.name}
            onChange={e => onChange({ ...address, name: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Empfängername"
            maxLength={60}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Straße</label>
          <input
            type="text"
            value={address.street}
            onChange={e => onChange({ ...address, street: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Straße und Hausnummer"
            maxLength={60}
          />
        </div>
        <div className="flex gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">PLZ</label>
            <input
              type="text"
              value={address.postal_code}
              onChange={e => onChange({ ...address, postal_code: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="PLZ"
              maxLength={10}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">Ort</label>
            <input
              type="text"
              value={address.city}
              onChange={e => onChange({ ...address, city: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Ort"
              maxLength={40}
            />
          </div>
        </div>
        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ihre persönliche E-Mail-Adresse
            <span className="block text-xs text-gray-500 font-normal">An diese Adresse wird die Bestellbestätigung versendet</span>
          </label>
          <input
            type="email"
            value={customerEmail}
            onChange={e => onEmailChange(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="E-Mail Adresse"
            required
          />
        </div> */}
      </div>
    </div>
  );
}
import React from 'react';

// Debounced update for invoice address (mirrors delivery address logic)
function useInvoiceAddressSync(invoiceAddress, customerEmail) {

}
// --- PATCH: Produkte in Bestellübersicht gruppieren und Mengen aufsummieren ---
// calculateOrderTotalPrice: Basispreis = (Menge / base_price_quantity) * base_price
// calculateOrderTotalPrice: Summe aller Einzelpositionen
function calculateOrderTotalPrice(orderItems) {
  // orderItems kann entweder die Cart-Items oder die order_summary sein
  // Wenn item_total vorhanden, summiere diese, sonst berechne wie bisher
  let sum = 0;
  orderItems.forEach(item => {
    if (typeof item.item_total === 'number') {
      sum += item.item_total;
    } else {
      const product = item.product;
      const quantity = item.quantity;
      let itemTotal = 0;
      const baseQty = product.base_price_quantity || 1;
      itemTotal += product.base_price * (quantity / baseQty);
      (item.options || []).forEach(optionId => {
        const option = product.options.find(opt => opt.id === optionId);
        if (option) {
          const optionQuantity = option.quantity || 1;
          const optionSets = Math.ceil(quantity / optionQuantity);
          itemTotal += option.price * optionSets;
        }
      });
      sum += itemTotal;
    }
  });
  return sum;
}
function MultiOrderSummary({ orderItems, onRemove, onEdit, personalization, pdfPreview, showPreviewModal, setStep, step }) {
  const [modalImg, setModalImg] = React.useState(null);
  return (
    <div className="bg-white p-6 rounded-xl shadow-md sticky top-4 pb-8 relative">
      {(typeof step !== 'undefined' && typeof setStep === 'function' && (step === 2 || step === 3 || step === 4)) && (
        <button
          onClick={() => setStep(1)}
          className="absolute top-2 right-2 px-3 py-1 bg-green-100 text-green-700 rounded hover:bg-green-200 text-xs font-semibold shadow"
          title="Weiteres Produkt hinzufügen"
          style={{ zIndex: 10 }}
        >
          + weiteres Produkt<br />
          hinzufügen
        </button>
      )}
      <h3 className="text-xl font-bold text-gray-800 mb-4">Bestellübersicht</h3>
      {/* Bildvorschau nur auf Delivery-Seite (step === 3) */}
      {pdfPreview && showPreviewModal && (
        <div className="mb-4">
          <h4 className="font-semibold text-gray-800 mb-2">Bild-Vorschau</h4>
          {/* <img
            src={`data:image/jpeg;base64,${pdfPreview}`}
            className="w-full h-48 object-contain border rounded-lg cursor-zoom-in"
            alt="PDF Vorschau als Bild"
            onClick={() => setModalImg(`data:image/jpeg;base64,${pdfPreview}`)}
          /> */}
          <img
            src={`data:image/jpeg;base64,${pdfPreview}`}
            className="border-2 border-grey-300"
            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
            // style={{ width: '241px', height: '156px', objectFit: 'contain' }}
            alt="PDF Vorschau als Bild"
            onClick={() => setModalImg(`data:image/jpeg;base64,${pdfPreview}`)}
          />
        </div>
      )}
      {/* Personalisierung als eigener Punkt unter dem Vorschaubild, jeweils in einer Zeile */}
      {personalization && (personalization.line1 || personalization.line2) && (
        <div className="mb-4">
          <h4 className="font-semibold text-gray-800 mb-2">Personalisierung</h4>
          <div className="text-sm text-gray-700 space-y-1">
            {personalization.line1 && <div>{personalization.line1}</div>}
            {personalization.line2 && <div>{personalization.line2}</div>}
          </div>
          <hr className="my-3" />
        </div>
      )}
      <div className="space-y-3">
        {orderItems.length === 0 ? (
          <div className="text-gray-400 text-sm text-center py-8">Noch keine Produkte im Warenkorb.<br />Wählen Sie links ein Produkt aus und fügen Sie es hinzu.</div>
        ) : (
          orderItems.map((item, idx) => (
            <div key={idx} className="mb-2 border-b pb-2 flex gap-4 items-start">
              {item.product.image_url && (
                <img
                  src={item.product.image_url}
                  alt={item.product.name}
                  className="h-12 w-auto rounded border border-gray-200 shadow-sm cursor-zoom-in"
                  style={{ maxWidth: '60px' }}
                  onClick={e => {
                    e.stopPropagation();
                    setModalImg(item.product.image_url);
                  }}
                />
              )}
              <div className="flex-1">
                <div className="flex justify-between items-center gap-2">
                  <span className="font-semibold leading-tight">{item.product.name}</span>
                  <span className="font-bold text-right min-w-[90px]">Menge: {item.quantity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                </div>
                {item.product.base_price_quantity === 1000 && (
                  <div className="text-sm text-gray-500 mt-2">
                    <span className="font-semibold">{item.product.base_price_quantity.toLocaleString('de-DE') + 'er Preis: ' + formatEuro(item.product.base_price)}</span>
                  </div>
                )}
                <div className="text-sm text-gray-500 mt-2 flex justify-between items-center gap-2">
                  <span>Kosten für Menge <span className="font-semibold">{item.quantity.toLocaleString('de-DE')}</span>:</span>
                  <span className="font-semibold text-right min-w-[100px]">{formatEuro(item.product.base_price * (item.quantity / (item.product.base_price_quantity || 1)))}</span>
                </div>
                {item.options && item.options.length > 0 && (
                  <div className="text-sm text-gray-500 mt-2">
                    Optionen:<br />
                    {item.options.map(id => {
                      const opt = item.product.options.find(o => o.id === id);
                      if (!opt) return null;
                      // Kosten für Option berechnen
                      const optionQuantity = opt.quantity || 1;
                      const optionSets = Math.ceil(item.quantity / optionQuantity);
                      const optionCost = opt.price * optionSets;
                      return (
                        <div key={id} className="flex justify-between items-center gap-2">
                          <span>{opt.name.replace(/\s*\(Einheitspreis:[^)]+\)/, '')}</span>
                          <span className="font-semibold text-right min-w-[100px]">{optionCost > 0 ? formatEuro(optionCost) : ''}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
                {/* Einzelpreis inkl. Optionen */}
                <div className="text-sm text-gray-800 mt-2 flex justify-between items-center gap-2 font-bold">
                  <span>Gesamtkosten für Position:</span>
                  <span className="text-right min-w-[100px]">{formatEuro(
                    (() => {
                      const product = item.product;
                      const quantity = item.quantity;
                      let itemTotal = 0;
                      const baseQty = product.base_price_quantity || 1;
                      itemTotal += product.base_price * (quantity / baseQty);
                      (item.options || []).forEach(optionId => {
                        const option = product.options.find(opt => opt.id === optionId);
                        if (option) {
                          const optionQuantity = option.quantity || 1;
                          const optionSets = Math.ceil(quantity / optionQuantity);
                          itemTotal += option.price * optionSets;
                        }
                      });
                      return itemTotal;
                    })()
                  )}</span>
                </div>
                <div className="flex flex-col gap-2 mt-2">
                  <button
                    onClick={() => onEdit(idx)}
                    className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded hover:bg-yellow-200 mb-1"
                  >
                    Bearbeiten
                  </button>
                  <button
                    onClick={() => onRemove(idx)}
                    className="bg-red-100 text-red-600 px-3 py-1 rounded hover:bg-red-200 mb-1"
                  >
                    Entfernen
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
        <hr className="my-3" />
        <div className="flex justify-between text-xl font-bold text-green-600">
          <span>Gesamt:</span>
          <span>{formatEuro(calculateOrderTotalPrice(orderItems))}</span>
        </div>
      </div>
      {modalImg && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setModalImg(null)}
        >
          <img
            src={modalImg}
            alt="Vorschau groß"
            // className="max-h-[80vh] max-w-[90vw] rounded shadow-lg border-4 border-white"
            style={{
              maxWidth: '800px',
              maxHeight: '650px',
              width: 'auto',
              height: 'auto',
              // borderRadius: '16px',
              boxShadow: '0 4px 32px rgba(0,0,0,0.25)',
              border: '4px solid #fff',
              background: '#fff',
              objectFit: 'contain'
            }}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
// InfoBox für Produktauswahl-Hinweis
function InfoBox() {
  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 rounded-xl shadow p-4 mb-8">
      <h2 className="text-lg font-bold mb-2 text-blue-700">Hinweis zur Produktauswahl</h2>
      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
        <li>Wählen Sie hier ein Produkt aus, das Sie bestellen möchten.</li>
        <li>Optional können Sie dann darunter die Zusatzoptionen für das Produkt auswählen.</li>
        <li>Geben Sie die gewünschte Auflage/Menge an.</li>
        <li>Klicken Sie auf <span className="font-semibold text-green-700">Produkt zur Bestellung hinzufügen</span>, um das Produkt in Ihre Bestellübersicht zu legen.</li>
        <li>Sie können mehrere Produkte nacheinander auswählen und hinzufügen. Wenn Sie alle Ihre Produkte der Bestellübersicht hinzugefügt haben, können Sie mit dem Button <span className="font-semibold text-blue-700">"Weiter zur Personalisierung"</span> fortfahren.</li>
      </ul>
    </div>
  );
}

// Hilfsfunktion für deutsche Preisformatierung
function formatEuro(value) {
  if (typeof value !== 'number') value = parseFloat(value);
  // If value is less than 10 and greater than 0, assume it's in Eurocent and convert
  // if (value < 10 && value > 0) value = value * 100;
  if (value < 10 && value > 0) value = value;
  return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

// Backend API URL from .env
const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Hilfskomponenten
function OptionSelector({ options, selectedOptions, onOptionChange, quantity }) {
  const groupedOptions = options.reduce((acc, option) => {
    const type = option.id.split('_')[0];
    if (!acc[type]) acc[type] = [];
    acc[type].push(option);
    return acc;
  }, {});
  // Hilfsfunktion für Einheitspreis
  function getUnitPriceText(option, type) {
    // Für Verarbeitungsoptionen (Größe): Einheitspreis immer anzeigen, aber Preis in Euro umrechnen
    const sizeOptionTypes = ["verarbeitung"];
    if (sizeOptionTypes.includes(type)) {
      if (option.price > 0 && option.quantity > 1) {
        return `Einheitspreis: ${formatEuro(option.price / 100)} pro ${option.quantity} Stück`;
      } else if (option.price > 0) {
        return `Einheitspreis: ${formatEuro(option.price / 100)} pro Stück`;
      }
      return null;
    }
    // Für andere Optionen: wie gehabt
    if (option.price > 0 && option.quantity > 1) {
      return `Einheitspreis: ${formatEuro(option.price)} pro ${option.quantity} Stück`;
    } else if (option.price > 0) {
      return `Einheitspreis: ${formatEuro(option.price)} pro Stück`;
    }
    return null;
  }
  return (
    <div className="space-y-6">
      {Object.entries(groupedOptions).map(([type, typeOptions]) => (
        <div key={type} className="bg-gray-50 p-4 rounded-lg">
          <h4 className="font-semibold text-gray-800 mb-3 capitalize">{type}optionen</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {typeOptions.map(option => (
              <div key={option.id} className="flex flex-col">
                <label className="flex items-start gap-3 cursor-pointer p-3 rounded-lg hover:bg-white transition-colors">
                  <input
                    type="radio"
                    name={type}
                    value={option.id}
                    checked={selectedOptions.includes(option.id)}
                    onChange={(e) => onOptionChange(type, e.target.value)}
                    className="w-4 h-4 text-blue-600 mt-1 flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <span className="block break-words">{option.name.replace(/\s*\(Einheitspreis:[^)]+\)/, '')}</span>
                    {getUnitPriceText(option, type) && (
                      <span className="text-xs text-gray-500 mt-1">{getUnitPriceText(option, type)}</span>
                    )}
                  </div>
                  <span className="font-semibold text-green-600 flex-shrink-0 ml-2">
                    {option.price > 0 ? '+' + formatEuro(Math.ceil(quantity / (option.quantity || 1)) * option.price) : ''}
                  </span>
                </label>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

// Footer-Komponente
function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-gray-100 dark:bg-gray-900 border-t border-gray-300 dark:border-gray-900 py-4 px-6 flex flex-col md:flex-row items-center justify-between fixed bottom-0 left-0 z-50">
      <div className="flex gap-4 text-sm">
        <a href="https://www.rieco.de/impressum.php" target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:underline dark:text-white">Impressum</a>
        <a href="https://www.rieco.de/datenschutz.php" target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:underline dark:text-white">Datenschutz</a>
      </div>
      <div className="text-xs text-gray-600 mt-2 md:mt-0">&copy; RIECO DRUCK + DATEN GmbH &amp; Co. KG {year}</div>
    </footer>
  );
}

function PersonalizationForm({ personalization, onChange, onPreview, orderItems, customerInfo, aspIdKdn }) {
  // Modal-Logik für Logo-Vorschau
  const [logoModalOpen, setLogoModalOpen] = React.useState(false);
  // FileMaker-Logo Base64 und aspIdKdn direkt aus dem Backend holen
  // const [filemakerLogoBase64, setFilemakerLogoBase64] = React.useState(null);
  const filemakerLogoBase64 = customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Logo_Base64'] || null;
  const [showTokenExpiredOverlay, setShowTokenExpiredOverlay] = React.useState(false);
  // aspIdKdn wird jetzt als Prop übergeben!
  // if (!personalization.logo_base64) {
  //   React.useEffect(() => {
  //     const token = window.sessionStorage.getItem('token');
  //     if (token) {
  //       fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
  //         headers: { Authorization: `Bearer ${token}` }
  //       })
  //         .then(res => res.json())
  //         .then(data => {
  //           const base64 = data?.all_fields?.['ASP.KDN::Schwarzwald_Logo_Base64'];
  //           if (base64 && typeof base64 === 'string' && base64.length > 0) {
  //             setFilemakerLogoBase64(base64);
  //           } else {
  //             setFilemakerLogoBase64(null);
  //           }
  //           const idKdn = data?.all_fields?.['ASP::ID.KDN'];
  //           if (idKdn) setAspIdKdn(idKdn);
  //         });
  //     }
  //   }, []);
  // }

  // Debounce-Logik analog zur AddressForm: useRef und useEffect
  const debounceTimer = React.useRef();
  const lastValues = React.useRef({ line1: personalization.line1, line2: personalization.line2 });
  React.useEffect(() => {
    // Nur senden, wenn sich Werte geändert haben
    if (lastValues.current.line1 !== personalization.line1 || lastValues.current.line2 !== personalization.line2 || lastValues.current.line1_bold !== personalization.line1_bold || lastValues.current.line2_bold !== personalization.line2_bold) {
      lastValues.current = { line1: personalization.line1, line2: personalization.line2, line1_bold: personalization.line1_bold, line2_bold: personalization.line2_bold };
      clearTimeout(debounceTimer.current);
      debounceTimer.current = setTimeout(async () => {
        const token = window.sessionStorage.getItem('token');
        if (!aspIdKdn) return;
        try {
          await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/update-kdn-eindruck', {
            asp_id_kdn: aspIdKdn,
            zeile_1: personalization.line1,
            zeile_2: personalization.line2,
            zeile_1_bold: personalization.line1_bold,
            zeile_2_bold: personalization.line2_bold
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } catch (err) {
          console.log(err);
          if (err.response && err.response.status === 401) {
            setShowTokenExpiredOverlay(true);
            if (typeof handleLogout === 'function') handleLogout();
          }
          // Sonstige Fehler ignorieren
        }
      }, 500);
    }
    return () => {
      clearTimeout(debounceTimer.current);
    };
  }, [personalization.line1, personalization.line2, personalization.line1_bold, personalization.line2_bold, personalization.logoBase64, aspIdKdn]);

  // orderItems jetzt als Prop
  const isNeutralOnly = orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102');
  // console.log('isNeutralOnly:', isNeutralOnly, 'orderItems:', orderItems);
  // Standard-Logo (z.B. RIECO)
  const standardLogo = '/images/schwarzwald_logo.png';
  return (
    <div className="bg-white p-6 rounded-xl shadow-md flex gap-8 items-start">
      {/* Logo-Vorschau links */}
      <div className="flex flex-col items-center justify-start" style={{ minWidth: '0' }}>
        {isNeutralOnly ? (
          <img
            src={standardLogo}
            alt="Standard Logo"
            className="rounded border border-gray-300 shadow mb-2 cursor-zoom-in"
            style={{ maxWidth: '96px', maxHeight: '96px', objectFit: 'contain', display: 'block' }}
            onClick={() => setLogoModalOpen(true)}
            title="Logo vergrößert anzeigen"
          />
        ) : filemakerLogoBase64 ? (
          <img
            src={`data:image/png;base64,${filemakerLogoBase64}`}
            alt="Logo Vorschau"
            className="rounded border border-gray-300 shadow mb-2 cursor-zoom-in"
            style={{ maxWidth: '96px', maxHeight: '96px', objectFit: 'contain', display: 'block' }}
            onClick={() => setLogoModalOpen(true)}
            title="Logo vergrößert anzeigen"
          />
        ) : (
          <img
            src={standardLogo}
            alt="Standard Logo"
            className="rounded border border-gray-300 shadow mb-2 cursor-zoom-in"
            style={{ maxWidth: '96px', maxHeight: '96px', objectFit: 'contain', display: 'block' }}
            onClick={() => setLogoModalOpen(true)}
            title="Logo vergrößert anzeigen"
          />
        )}
        <span className="text-xs text-gray-500 mt-1">Logo-Vorschau</span>
        {logoModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
            onClick={() => setLogoModalOpen(false)}
            style={{}}
          >
            <img
              src={isNeutralOnly ? standardLogo : filemakerLogoBase64 ? `data:image/png;base64,${filemakerLogoBase64}` : standardLogo}
              alt="Logo groß"
              style={{
                maxWidth: '90vw',
                maxHeight: '80vh',
                minWidth: '200px',
                minHeight: '200px',
                width: 'auto',
                height: 'auto',
                borderRadius: '4px',
                boxShadow: '0 4px 32px rgba(0,0,0,0.25)',
                border: '4px solid #fff',
                background: '#fff',
                objectFit: 'contain',
                display: 'block',
              }}
              onClick={e => e.stopPropagation()}
            />
          </div>
        )}
      </div>
      {/* Eingabefelder rechts */}
      <div className="flex-1">
        <h3 className="text-xl font-bold text-gray-800 mb-4">Personalisierung Ihrer Gästekarte</h3>
        <p className="text-gray-700 mb-6">
          {isNeutralOnly
            ? 'Für neutrale Produkte ist keine Personalisierung möglich. Es wird das Standard-Logo verwendet und die Textfelder sind deaktiviert.'
            : 'Das angezeigte Logo auf der linken Seite ist aktuell für Sie im System hinterlegt. Wenn Sie dieses Logo ändern möchten können Sie dies direkt über die untenstehende Upload-Funktion aktualisieren und auf Wunsch auch als Standard für weitere zukünftige Bestellungen speichern.\n\nSie können Ihre Gästekarte auch mit zwei individuellen Textzeilen personalisieren. Nutzen Sie dazu die Eingabefelder unten. Wenn Sie keinen zusätzlichen Text zu ihrem Logo wünschen, können sie diese Textfelder einfach leer lassen.'}
        </p>
        {/* Textfelder nur anzeigen, wenn nicht ausschließlich neutrale Produkte */}
        {!isNeutralOnly && (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Zeile 1</label>
              <div className="flex items-center gap-3">
                <div className="relative w-full">
                  <input
                    type="text"
                    value={personalization.line1}
                    onChange={e => {
                      const newLine1 = e.target.value;
                      onChange({ ...personalization, line1: newLine1 });
                    }}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
                    placeholder="Erste Textzeile eingeben"
                    maxLength={50}
                  />
                  {personalization.line1 && (
                    <div className="relative inline-block">
                      <Tooltip text="Feld leeren" position="right">
                        <button
                          type="button"
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 hover:border-red-400 bg-transparent text-gray-500 hover:text-red-600 focus:outline-none"
                          style={{ padding: 0, borderWidth: 0.1, cursor: 'pointer', background: 'none', marginTop: '-6px' }}
                          tabIndex={-1}
                          aria-label="Feld leeren"
                          onClick={() => onChange({ ...personalization, line1: '' })}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 20 20" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.7} d="M6 6l8 8M6 14L14 6" />
                          </svg>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                </div>
                <label className="flex items-center gap-2 text-xs select-none">
                  <span>Fett</span>
                  <Tooltip text="Schrift fett/bold stellen">
                    <button
                      type="button"
                      aria-pressed={!!personalization.line1_bold}
                      onClick={() => onChange({ ...personalization, line1_bold: !personalization.line1_bold })}
                      className={`relative inline-flex h-6 w-11 rounded-full transition-colors focus:outline-none ${personalization.line1_bold ? 'bg-blue-600' : 'bg-gray-300'}`}
                      style={{ minWidth: 44 }}
                    >
                      <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${personalization.line1_bold ? 'translate-x-5' : 'translate-x-1'}`}
                        style={{ marginTop: 2 }}
                      />
                    </button>
                  </Tooltip>
                </label>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Zeile 2</label>
              <div className="flex items-center gap-3">
                <div className="relative w-full">
                  <input
                    type="text"
                    value={personalization.line2}
                    onChange={e => {
                      const newLine2 = e.target.value;
                      onChange({ ...personalization, line2: newLine2 });
                    }}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
                    placeholder="Zweite Textzeile eingeben"
                    maxLength={50}
                  />
                  {personalization.line2 && (
                    <div className="relative inline-block">
                      <Tooltip text="Feld leeren" position="right">
                        <button
                          type="button"
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 hover:border-red-400 bg-transparent text-gray-500 hover:text-red-600 focus:outline-none"
                          style={{ padding: 0, borderWidth: 0.1, cursor: 'pointer', background: 'none', marginTop: '-6px' }}
                          tabIndex={-1}
                          aria-label="Feld leeren"
                          onClick={() => onChange({ ...personalization, line2: '' })}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" fill="none" viewBox="0 0 20 20" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.7} d="M6 6l8 8M6 14L14 6" />
                          </svg>
                        </button>
                      </Tooltip>
                    </div>
                  )}
                </div>
                <label className="flex items-center gap-2 text-xs select-none">
                  <span>Fett</span>
                  <Tooltip text="Schrift fett/bold stellen">
                    <button
                      type="button"
                      aria-pressed={!!personalization.line2_bold}
                      onClick={() => onChange({ ...personalization, line2_bold: !personalization.line2_bold })}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${personalization.line2_bold ? 'bg-blue-600' : 'bg-gray-300'}`}
                      style={{ minWidth: 44 }}
                    >
                      <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${personalization.line2_bold ? 'translate-x-5' : 'translate-x-1'}`}
                      />
                    </button>
                  </Tooltip>
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// Hilfsfunktion: Kundendaten vom Backend holen und Adresse setzen
async function fetchAndAutofillCustomerInfo(token, setAddress, setCustomerEmail) {
  if (!token) return;
  try {
    const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    // Filter: Nur Adressen mit 'L' in Adressart_Kürzel und '1' in Anschriftwahl_STG_Lieferung
    let addr = {};
    if (Array.isArray(data?.lieferadressen)) {
      addr = data.lieferadressen.find(a => {
        const kuerzel = a['ASP.ADR.ADR::Adressart_Kürzel'] || '';
        const anschriftwahl = a['ASP.ADR.ADR::Anschriftwahl_STG_Lieferung'] || '';
        // 'L' muss als Buchstabe enthalten sein (z.B. 'L', 'L/R', ...)
        // Anschriftwahl muss exakt '1' sein
        return kuerzel.includes('L') && String(anschriftwahl).trim() === '1';
      }) || {};
    } else {
      addr = data?.lieferadresse_fields || {};
    }
    let recid = addr['RecID'] || addr['recid'] || addr['RECID'] || addr['RecordID'] || null;
    let institution = addr['ASP.ADR.ADR::Institution'] || '';
    let adresszusatz = addr['ASP.ADR.ADR::Adresszusatz'] || '';
    let name = addr['ASP.ADR.ADR::Empfänger'] || '';
    let street = addr['ASP.ADR.ADR::Straße'] || data?.street || '';
    let city = addr['ASP.ADR.ADR::Ort'] || data?.city || '';
    let postal_code = addr['ASP.ADR.ADR::PLZ_Straße'] || addr['ASP.ADR.ADR::PLZ der Straße'] || data?.postal_code || '';
    setAddress({ institution, adresszusatz, name, street, city, postal_code, recid });
    // E-Mail aus FileMaker übernehmen
    let email = data?.email || (data?.all_fields && data.all_fields['ASP.KDN::E-Mail']) || '';
    if (setCustomerEmail && email) setCustomerEmail(email);
  } catch (err) {
    // Fehler ignorieren, Adresse bleibt leer
    setAddress(addr => ({ ...addr })); // recid bleibt erhalten, falls vorhanden
  }
}

function App() {
  // Overlay für Token-Ablauf global rendern
  // Overlay für Token-Ablauf (401)
  const [showTokenExpiredOverlay, setShowTokenExpiredOverlay] = React.useState(false);

  // Handler für Token-Expired-Overlay
  const handleTokenExpiredOk = () => {
    setShowTokenExpiredOverlay(false);
    // handleLogout() wurde bereits beim Fehler ausgeführt
  };
  if (showTokenExpiredOverlay) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col min-h-screen bg-black bg-opacity-20">
        <header className="bg-white dark:bg-gray-900 shadow-md py-6 sticky top-0 z-20">
          <div className="max-w-5xl mx-auto px-4 flex items-center">
            <div className="flex items-center gap-6 flex-shrink-0">
              <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '48px', width: 'auto' }} />
              <img src="/images/rieco_logo.png" alt="RIECO Logo" style={{ height: '48px', width: 'auto' }} />
              <span className="text-3xl font-bold tracking-tight">
                <span className="font-bold text-[#e30613] dark:text-red-400">{PORTAL_NAME}</span>
                <span className="ml-2 text-[#0a2239] dark:text-white"><br />Bestellportal</span>
              </span>
            </div>
            <div className="flex-1" />
          </div>
        </header>
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Sitzung abgelaufen</h2>
            <p className="text-gray-600 mb-6">Ihr Login-Token ist abgelaufen oder ungültig. Bitte melden Sie sich erneut an.</p>
            <button
              onClick={handleTokenExpiredOk}
              className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold"
            >OK</button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  // Login-Handler für das Login-Formular
  const [loginError, setLoginError] = React.useState("");
  const handleLogin = async (username, password) => {
    // console.log('handleLogin aufgerufen mit:', username, password);
    // Schutz: Nur String als Username zulassen
    if (typeof username !== 'string') {
      setEmailError('Login-Fehler: Benutzername ist kein String!');
      return;
    }
    setLoading(true);
    setEmailError('');
    setLoginError("");
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      // console.log('Login-Response Status:', res.status);
      let data = null;
      try {
        data = await res.json();
        // console.log('Login-Response JSON:', data);
      } catch (jsonErr) {
        console.error('Fehler beim Parsen der Login-Response als JSON:', jsonErr);
        setEmailError('Fehler beim Verarbeiten der Serverantwort');
        setLoading(false);
        return;
      }
      if (res.ok && data.token) {
        setToken(data.token);
        window.sessionStorage.setItem('token', data.token);
        // lastOrderNumbers direkt aus Login-Response setzen, falls vorhanden
        if (Array.isArray(data.last_order_numbers) && data.last_order_numbers.length > 0) {
          const nextOrderNumber = Number(data.last_order_numbers[0]) + 1;
          setLastOrderNumbers([nextOrderNumber]);
          setEditableOrderNumber(String(nextOrderNumber));
        } else {
          setLastOrderNumbers([]);
          setEditableOrderNumber('');
        }
        // ...existing code...
        setOrderComplete(false);
        setCurrentStep(1);
        setStep(-1);
        setOrderItems([]);
        setCurrentProduct(null);
        setCurrentOptions([]);
        setCurrentQuantity(1);
        setCurrentPersonalization({ line1: '', line2: '' });
        setCurrentPdfPreview(null);
        setNotes('');
        setOrderDetails(null);
        setAddress({ name: '', street: '', city: '', postal_code: '', recid: null });
        setCustomerEmail('');
      } else {
        setEmailError(data.detail || 'Login fehlgeschlagen');
        setLoginError(data.detail || 'Login fehlgeschlagen');
      }
    } catch (err) {
      console.error('Fehler im Login-Request:', err);
      setEmailError('Serverfehler beim Login');
      setLoginError('Serverfehler beim Login');
    }
    setLoading(false);
  };
  // Token muss als erstes deklariert werden, da es in anderen States/Effekten benötigt wird
  const [token, setToken] = React.useState(() => window.sessionStorage.getItem('token') || null);
  // Token muss als erstes deklariert werden, da es in anderen States/Effekten benötigt wird
  // (token/setToken ist bereits ganz oben deklariert)
  // Token muss als erstes deklariert werden, da es in anderen States/Effekten benötigt wird
  // (token/setToken ist bereits ganz oben deklariert)
  const [begruessung, setBegruessung] = React.useState('');
  const [typewriterPlayed, setTypewriterPlayed] = React.useState(() => {
    return window.sessionStorage.getItem('typewriterPlayed') === 'true';
  });

  // Hilfsfunktion: Prüfe Pflichtfelder für Rechnungsadresse
  function getInvoiceAddressMissingFields() {
    const missing = [];
    if (!invoiceAddress.institution?.trim()) missing.push('Firmenname Zeile 1');
    if (!invoiceAddress.street?.trim()) missing.push('Straße');
    if (!invoiceAddress.postal_code?.trim()) missing.push('PLZ');
    if (!invoiceAddress.city?.trim()) missing.push('Ort');
    if (!customerEmail?.trim()) missing.push('E-Mail');
    else if (!isValidEmail(customerEmail)) missing.push('gültige E-Mail');
    return missing;
  }
  // --- Dark Mode State & Effect ---
  const [darkMode, setDarkMode] = React.useState(() => {
    return window.localStorage.getItem('darkMode') === 'true';
  });
  React.useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
      window.localStorage.setItem('darkMode', 'true');
    } else {
      document.body.classList.remove('dark');
      window.localStorage.setItem('darkMode', 'false');
    }
  }, [darkMode]);
  // State für globales Produktbild-Modal
  const [productImageModal, setProductImageModal] = React.useState({ open: false, src: '', alt: '' });

  // Handler für Produktbild-Klick (öffnet globales Modal)
  const handleProductImageClick = (src, alt) => {
    setProductImageModal({ open: true, src, alt });
  };
  // Alle State-Deklarationen zuerst!
  // Token muss als erstes deklariert werden, da es in anderen States/Effekten benötigt wird
  // Zentraler State für Kundendaten
  const [customerInfo, setCustomerInfo] = React.useState(null);
  // Lädt die Kundendaten und speichert sie zentral
  const fetchCustomerInfo = React.useCallback(async (token) => {
    // console.log('fetchCustomerInfo aufgerufen mit Token:', token);
    if (!token) return;
    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      // Fallback: last_order_numbers aus Login-JSON übernehmen, falls vorhanden
      if ((!Array.isArray(data.last_order_numbers) || data.last_order_numbers.length === 0) && window.sessionStorage.getItem('loginJson')) {
        try {
          const loginJson = JSON.parse(window.sessionStorage.getItem('loginJson'));
          if (Array.isArray(loginJson.last_order_numbers) && loginJson.last_order_numbers.length > 0) {
            data.last_order_numbers = loginJson.last_order_numbers;
          }
        } catch (e) { /* ignore */ }
      }
      if (data.all_fields && Object.prototype.hasOwnProperty.call(data.all_fields, "eBusiness Passwort")) {
        data.all_fields["eBusiness Passwort"] = "";
      }
      setCustomerInfo(data);
      // console.log('CustomerInfo nach Clean Login:', data);
    } catch (err) {
      setCustomerInfo(null);
    }
  }, []);

  // Nach Login oder Token-Initialisierung: Kundendaten laden
  React.useEffect(() => {
    if (token) {
      fetchCustomerInfo(token);
    } else {
      setCustomerInfo(null);
    }
  }, [token, fetchCustomerInfo]);
  // State für Kundeninformationen
  // (bereits weiter oben deklariert)
  // State für Rechnungsadresse (InvoiceAddressForm)
  const [invoiceAddress, setInvoiceAddress] = React.useState({ name: '', street: '', city: '', postal_code: '', institution: '', adresszusatz: '', recid: null });
  // State für letzte Auftragsnummern
  const [lastOrderNumbers, setLastOrderNumbers] = React.useState([]);
  // State für editierbare Auftragsnummer
  const [editableOrderNumber, setEditableOrderNumber] = React.useState('');
  // State declarations FIRST
  const [products, setProducts] = React.useState([]);
  // Tab-Logik für Produktarten (nach products-Initialisierung!)
  const [productTab, setProductTab] = React.useState('manuell');
  // Initialisiere Tab nach Laden der Produkte
  React.useEffect(() => {
    if (products.length > 0) {
      const elektronischeProdukte = products.filter(p => typeof p.id === 'string' && (p.id.startsWith('E') || p.id.startsWith('H')));
      const manuelleProdukte = products.filter(p => !(typeof p.id === 'string' && (p.id.startsWith('E') || p.id.startsWith('H'))));
      if (elektronischeProdukte.length > 0 && manuelleProdukte.length === 0) {
        setProductTab('elektronisch');
      } else {
        setProductTab('manuell');
      }
    }
  }, [products]);
  // Tab-Wechsel: Auswahl zurücksetzen
  const handleTabChange = (tab) => {
    setProductTab(tab);
    setCurrentProduct(null);
    setCurrentOptions([]);
    setCurrentQuantity(1);
    setCurrentPersonalization({ line1: '', line2: '' });
    setCurrentPdfPreview(null);
  };
  // Filter für elektronische Produkte: Zeigt Produkte, deren ID mit 'E' oder 'H' beginnt
  // Wenn du möchtest, dass z.B. nur 'E' angezeigt wird, ändere zu: p.id.startsWith('E')
  const elektronischeProdukte = products.filter(p => typeof p.id === 'string' && (p.id.startsWith('E') || p.id.startsWith('H')));
  // Filter für manuelle Produkte: Zeigt alle anderen Produkte
  const manuelleProdukte = products.filter(p => !(typeof p.id === 'string' && (p.id.startsWith('E') || p.id.startsWith('H'))));
  const tabProdukte = productTab === 'elektronisch' ? elektronischeProdukte : manuelleProdukte;
  const [currentStep, setCurrentStep] = React.useState(1);
  const [orderComplete, setOrderComplete] = React.useState(false);
  const [fmResult, setFmResult] = React.useState(null);
  const [fmLoading, setFmLoading] = React.useState(false);
  const handleCreateFilemaker = async () => {
    setLoading(true);
    setFmLoading(true);
    setFmResult(null);
    try {
      const token = window.sessionStorage.getItem('token');
      const productsPayload = orderItems.map(item => ({
        product_id: item.product?.id || item.product_id,
        quantity: item.quantity,
        selected_options: item.selected_options || item.options || [],
        gmk_param: item.product?.gmk_param
      }));
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/create-filemaker-bestellung', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          products: productsPayload,
          nummerierung_von: editableOrderNumber || undefined
        })
      });
      const data = await res.json();
      setFmResult(data);

      // Debug: Logge FileMaker-Antwort immer
      // console.log('[DEBUG] FileMaker-Bestellung Antwort:', data);
      // Order-Objekt anreichern und an handleSubmitOrder übergeben
      // handleSubmitOrder immer aufrufen, wenn kein Fehler im Response ist
      if (data && !data.error) {
        setFmResult(data); // bleibt für UI/Debug
        await handleSubmitOrder({ auftragsbearbeitung: data.auftragsbearbeitung });
      }
    } catch (e) {
      setFmResult({ error: e.message });
    }
    setFmLoading(false);
  };
  // --- Automatischer Logout nach 20 Minuten Inaktivität mit Overlay ---
  const [showInactivityOverlay, setShowInactivityOverlay] = React.useState(false);
  React.useEffect(() => {
    if (!token) return;
    let timeoutId;
    // const INACTIVITY_LIMIT = 10 * 1000; // 10 Sekunden (Test)
    const INACTIVITY_LIMIT = 10 * 60 * 1000; // 10 Minuten / DATA-API wird nach 15 Minuten ungültig
    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        // console.log('Inactivity timeout reached, showing overlay');
        setShowInactivityOverlay(true);
      }, INACTIVITY_LIMIT);
    };
    // const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timeoutId);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [token]);

  const handleInactivityOk = () => {
    setShowInactivityOverlay(false);
    handleLogout();
  };

  // // Hilfsfunktion: lastOrderNumbers aus /api/customer-info aktualisieren
  // async function fetchAndSetLastOrderNumbers(token) {
  //   if (!token) return;
  //   try {
  //     const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
  //       headers: { Authorization: `Bearer ${token}` }
  //     });
  //     const data = await res.json();
  //     if (Array.isArray(data?.last_order_numbers) && data.last_order_numbers.length > 0) {
  //       setLastOrderNumbers([Number(data.last_order_numbers[0]) + 1]);
  //     } else {
  //       setLastOrderNumbers([]);
  //     }
  //   } catch (e) {
  //     setLastOrderNumbers([]);
  //   }
  // }

  // Produkte neu laden Funktion (außerhalb von useState, damit überall verfügbar)
  const reloadProducts = async () => {
    if (!token) return;
    try {
      setLoading(true);
      const res = await axios.get(`${API}/products`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const products = Array.isArray(res.data) ? res.data : res.data.products || [];
      setProducts(products);
      // Auswahl zurücksetzen
      setCurrentProduct(null);
      setCurrentOptions([]);
      setCurrentQuantity(1);
      setCurrentPersonalization({ line1: '', line2: '' });
      setCurrentPdfPreview(null);
      // Warenkorb bereinigen: Entferne Produkte, die nicht mehr verfügbar sind
      setOrderItems(orderItems => orderItems.filter(item => products.some(p => p.id === item.product.id)));
    } catch (err) {
      if (err.response && err.response.status === 403) {
        alert('Ihre Sitzung ist abgelaufen oder Sie sind nicht mehr berechtigt. Bitte melden Sie sich erneut an.');
        handleLogout();
      } else {
        console.error('Produkte neu laden fehlgeschlagen:', err);
      }
    } finally {
      setLoading(false);
    }
  };
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [quantity, setQuantity] = React.useState(1);
  const [personalization, setPersonalization] = React.useState({ line1: '', line2: '', line1_bold: false, line2_bold: false, logo_base64: null });
  const [pdfPreview, setPdfPreview] = React.useState(null);
  const [address, setAddress] = React.useState({ name: '', street: '', city: '', postal_code: '', recid: null });
  const [customerEmail, setCustomerEmail] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [notes, setNotes] = React.useState('');
  const [orderDetails, setOrderDetails] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  // Neue State für mehrere Produkte
  const [orderItems, setOrderItems] = React.useState([]);
  const [currentProduct, setCurrentProduct] = React.useState(null);
  const [currentOptions, setCurrentOptions] = React.useState([]);
  // Immer erste Option pro Typ vorauswählen, wenn currentProduct sich ändert,
  // aber nur wenn keine Optionen gesetzt sind (z.B. bei Neuauswahl, nicht beim Bearbeiten)
  React.useEffect(() => {
    if (currentProduct && Array.isArray(currentProduct.options)) {
      if (!currentOptions || currentOptions.length === 0) {
        const grouped = currentProduct.options.reduce((acc, option) => {
          const type = option.id.split('_')[0];
          if (!acc[type]) acc[type] = [];
          acc[type].push(option);
          return acc;
        }, {});
        const defaultOptions = Object.values(grouped).map(options => options[0]?.id).filter(Boolean);
        setCurrentOptions(defaultOptions);
      }
      // Sonst: Optionen bleiben erhalten
    } else {
      setCurrentOptions([]);
    }
  }, [currentProduct]);
  const [currentQuantity, setCurrentQuantity] = React.useState(1);
  const [currentPersonalization, setCurrentPersonalization] = React.useState({ line1: '', line2: '' });
  const [currentPdfPreview, setCurrentPdfPreview] = React.useState(null);
  const [step, setStep] = React.useState(-1);

  //   // Debug: Logge lastOrderNumbers und step bei jeder Änderung
  // React.useEffect(() => {
  //   console.log('[App] step:', step, 'lastOrderNumbers:', lastOrderNumbers);
  // }, [step, lastOrderNumbers]);

  // // lastOrderNumbers bei jedem Aufruf von Schritt 4 (Rechnungsadresse) aktualisieren
  // React.useEffect(() => {
  //   if (step === 4 && token) {
  //     fetchAndSetLastOrderNumbers(token);
  //   }
  // }, [step, token]);
  // Neuer State: vorheriger Schritt für Bearbeitungs-Workflow
  const [previousStep, setPreviousStep] = React.useState(null);

  // Scroll to top when entering Personalisierungsseite (step 2) or Lieferadresse-Seite (step 3)
  React.useEffect(() => {
    if (step === 2 || step === 3 || step === 4) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [step]);
  // PDF Vorschau in Schritt 2 live aktualisieren mit Ladeanimation
  const [previewLoading, setPreviewLoading] = React.useState(false);
  // Logo-Upload States
  const MAX_LOGO_WIDTH = 4000;
  const MAX_LOGO_HEIGHT = 4000;
  const [logoError, setLogoError] = React.useState('');
  const [logoFile, setLogoFile] = React.useState(null);
  const [logoPreview, setLogoPreview] = React.useState(null);
  const [logoUploading, setLogoUploading] = React.useState(false);
  const [logoModalOpen, setLogoModalOpen] = React.useState(false);
  // NEU: Soll das Logo als Standard gespeichert werden?
  const [setAsDefaultLogo, setSetAsDefaultLogo] = React.useState(true);
  // Separate Vorschau für das Icon bei PDF/EPS
  const [pdfIconPreview, setPdfIconPreview] = React.useState(null);
  // --- PATCH: PDF-Vorschau nutzt FileMaker-Logo als Fallback ---
  const [filemakerLogoBase64, setFilemakerLogoBase64] = React.useState(null);
  React.useEffect(() => {
    if (!personalization.logo_base64) {
      // Versuche zuerst das Logo aus customerInfo zu nehmen
      const base64 = customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Logo_Base64'];
      if (base64 && typeof base64 === 'string' && base64.length > 0) {
        setFilemakerLogoBase64(base64);
      } else {
        // Fallback: Hole Logo per API, falls nicht vorhanden
        const token = window.sessionStorage.getItem('token');
        if (token) {
          fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
            headers: { Authorization: `Bearer ${token}` }
          })
            .then(res => res.json())
            .then(data => {
              const base64 = data?.all_fields?.['ASP.KDN::Schwarzwald_Logo_Base64'];
              if (base64 && typeof base64 === 'string' && base64.length > 0) {
                setFilemakerLogoBase64(base64);
              } else {
                setFilemakerLogoBase64(null);
              }
            });
        }
      }
    }
  }, [personalization.logo_base64, customerInfo]);
  React.useEffect(() => {
    // Nach Laden der Kundendaten initiale Adresse und E-Mail setzen
    if (Array.isArray(customerInfo?.lieferadressen) && customerInfo.lieferadressen.length > 0) {
      setAddress(customerInfo.lieferadressen[0]);
    } else {
      setAddress({});
    }
    // lastOrderNumbers direkt aus der Response setzen
    if (Array.isArray(customerInfo?.last_order_numbers) && customerInfo.last_order_numbers.length > 0) {
      setLastOrderNumbers([Number(customerInfo.last_order_numbers[0]) + 1]);
    } else {
      setLastOrderNumbers([]);
    }
    // Adresse setzen
    let addr = {};
    if (Array.isArray(customerInfo?.lieferadressen)) {
      addr = customerInfo.lieferadressen.find(a => {
        const kuerzel = a['ASP.ADR.ADR::Adressart_Kürzel'] || '';
        const anschriftwahl = a['ASP.ADR.ADR::Anschriftwahl_STG_Lieferung'] || '';
        return kuerzel.includes('L') && String(anschriftwahl).trim() === '1';
      }) || {};
    } else {
      addr = customerInfo?.lieferadresse_fields || {};
    }
    // console.log('Raw Lieferadresse:', addr);
    let begr = customerInfo?.all_fields?.['Begruessung_STG_Portal'];
    if (begr && typeof begr === 'string') {
      begr = begr.replace(/\r\n|\r/g, '\n').replace(/<br\s*\/?>/gi, '\n').trim();
      setBegruessung(begr);
      // console.log('Begrüßung aus FileMaker:', begr);
    } else {
      setBegruessung('');
      // console.log('Begrüßung aus FileMaker: leer');
    }
    let recid = addr['RecID'] || addr['recid'] || addr['RECID'] || addr['RecordID'] || null;
    let institution = addr['ASP.ADR.ADR::Institution'] || '';
    let adresszusatz = addr['ASP.ADR.ADR::Adresszusatz'] || '';
    let name = addr['ASP.ADR.ADR::Empfänger'] || '';
    let street = addr['ASP.ADR.ADR::Straße'] || '';
    let city = addr['ASP.ADR.ADR::Ort'] || '';
    let postal_code = addr['ASP.ADR.ADR::PLZ_Straße'] || addr['ASP.ADR.ADR::PLZ der Straße'] || '';
    // Fallback auf all_fields falls keine passende Lieferadresse gefunden
    // if (!institution && data?.all_fields) {
    //   const fields = data.all_fields;
    //   recid = fields['RecID'] || fields['recid'] || fields['RECID'] || null;
    //   institution = fields['ASP.KDN::Institution'] || '';
    //   adresszusatz = fields['ASP.KDN::Adresszusatz'] || '';
    //   name = fields['ASP.KDN::Name'] || '';
    //   street = fields['ASP.KDN::Strasse'] || '';
    //   city = fields['ASP.KDN::Ort'] || '';
    //   postal_code = fields['ASP.KDN::PLZ'] || '';
    // }
    setAddress({ institution, adresszusatz, name, street, city, postal_code, recid });
    // Rechnungsadresse setzen (analog zur Lieferadresse)
    let invoiceAddr = {};
    if (Array.isArray(customerInfo?.rechnungsadresse_fields)) {
      invoiceAddr = customerInfo.rechnungsadresse_fields.find(a => {
        const kuerzel = a['ASP.ADR.ADR::Adressart_Kürzel'] || '';
        const anschriftwahl = a['ASP.ADR.ADR::Anschriftwahl_STG_Rechnung'] || '';
        return kuerzel.includes('R') && String(anschriftwahl).trim() === '1';
      }) || {};
    } else {
      invoiceAddr = customerInfo?.rechnungsadresse_fields || {};
    }
    let inv_recid = invoiceAddr['RecID'] || invoiceAddr['recid'] || invoiceAddr['RECID'] || invoiceAddr['RecordID'] || null;
    let inv_institution = invoiceAddr['ASP.ADR.ADR::Institution'] || '';
    let inv_adresszusatz = invoiceAddr['ASP.ADR.ADR::Adresszusatz'] || '';
    let inv_name = invoiceAddr['ASP.ADR.ADR::Empfänger'] || invoiceAddr['ASP.KDN::Name'] || '';
    let inv_street = invoiceAddr['ASP.ADR.ADR::Straße'] || invoiceAddr['ASP.KDN::Strasse'] || '';
    let inv_city = invoiceAddr['ASP.ADR.ADR::Ort'] || invoiceAddr['ASP.KDN::Ort'] || '';
    let inv_postal_code = invoiceAddr['ASP.ADR.ADR::PLZ_Straße'] || invoiceAddr['ASP.ADR.ADR::PLZ der Straße'] || invoiceAddr['ASP.KDN::PLZ'] || '';
    setInvoiceAddress({ institution: inv_institution, adresszusatz: inv_adresszusatz, name: inv_name, street: inv_street, city: inv_city, postal_code: inv_postal_code, recid: inv_recid });
    // console.log('Full /api/customer-info response:', data);
    // console.log('Raw rechnungsadresse_fields:', data.rechnungsadresse_fields);
    // E-Mail aus FileMaker übernehmen
    let email = customerInfo?.email || (customerInfo?.all_fields && customerInfo.all_fields['ASP.KDN::E-Mail']) || '';
    if (email) setCustomerEmail(email);
    // Personalisierungsfelder aus SW_Info_Eindrucke übernehmen
    // Die Felder heißen: Schwarzwald_Eindruck_Zeile_1 und Schwarzwald_Eindruck_Zeile_2
    setPersonalization({
      line1: customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_1'] || '',
      line2: customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_2'] || '',
      line1_bold: customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_1_Bold'] === '1',
      line2_bold: customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_2_Bold'] === '1'
    });
    // Logo aus FileMaker
    const base64 = customerInfo?.all_fields?.['ASP.KDN::Schwarzwald_Logo_Base64'];
    if (base64 && typeof base64 === 'string' && base64.length > 0) {
      setFilemakerLogoBase64(base64);
    } else {
      setFilemakerLogoBase64(null);
    }
  }, [customerInfo]);

  // --- PATCH: PDF-Base64 aus Preview-API speichern mit Debounce ---
  const [pdfBase64, setPdfBase64] = React.useState(null);
  const debouncePreviewTimer = React.useRef();
  React.useEffect(() => {
    let active = true;
    if (step === 2) {
      // Debounce: Nur nach 500ms Pause neu rendern
      clearTimeout(debouncePreviewTimer.current);
      debouncePreviewTimer.current = setTimeout(() => {
        setPreviewLoading(true);
        setPdfPreview(null);
        setPdfBase64(null);
        const fetchPreview = async () => {
          try {
            let payload;
            const isNeutralOnly = orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102');
            if (isNeutralOnly) {
              // Nur neutrales Logo-Bild, keine Textzeilen
              let neutralLogoBase64 = null;
              try {
                // Fetch neutral logo as base64 from public folder
                const res = await fetch('/images/schwarzwald_logo.png');
                const blob = await res.blob();
                const reader = new window.FileReader();
                const base64Promise = new Promise(resolve => {
                  reader.onloadend = () => {
                    // Remove data:image/png;base64, prefix
                    const result = reader.result;
                    const match = result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                    resolve(match ? match[2] : result);
                  };
                });
                reader.readAsDataURL(blob);
                neutralLogoBase64 = await base64Promise;
              } catch (e) {
                neutralLogoBase64 = null;
              }
              payload = {
                product_ids: orderItems.map(item => item.product?.id),
                logo_base64: neutralLogoBase64,
                line1: '',
                line2: '',
                line1_bold: false,
                line2_bold: false
              };
            } else {
              payload = {
                ...personalization,
                line1_bold: !!personalization.line1_bold,
                line2_bold: !!personalization.line2_bold
              };
              payload.product_ids = orderItems.map(item => item.product?.id);
              if (logoPreview) {
                const match = logoPreview.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                payload.logo_base64 = match ? match[2] : logoPreview;
              } else if (filemakerLogoBase64) {
                payload.logo_base64 = filemakerLogoBase64;
              } else {
                payload.logo_base64 = null;
              }
            }
            const res = await axios.post(`${API}/preview-pdf`, payload);
            // Debug: Log payload for PDF preview
            // console.log('[DEBUG] /api/preview-pdf payload:', payload);
            if (active) {
              setPdfPreview(res.data.jpg_base64);
              setPdfBase64(res.data.pdf_base64 || null);
              // Falls reiner Eindruck separat geliefert wird, aktualisiere auch diesen State
              if (res.data.pure_pdf_base64) {
                setPdfBase64(res.data.pure_pdf_base64);
              }
              setPreviewLoading(false);
            }
          } catch (err) {
            if (active) {
              setPdfPreview(null);
              setPdfBase64(null);
              setPreviewLoading(false);
            }
          }
        };
        fetchPreview();
      }, 500);
    }
    return () => {
      active = false;
      clearTimeout(debouncePreviewTimer.current);
    };
  }, [step, personalization.line1, personalization.line2, personalization.line1_bold, personalization.line2_bold, logoPreview, filemakerLogoBase64, orderItems]);

  const handleNewOrder = () => {
    setOrderComplete(false);
    setOrderDetails(null);
    setCurrentStep(1); // Für Logik mit currentStep
    setStep(1); // Für Multi-Step UI
    setSelectedProduct(null);
    setSelectedOptions([]);
    setQuantity(1);
    // Do NOT clear personalization fields here!
    // setPersonalization({ line1: '', line2: '' });
    setPdfPreview(null);
    // Clear notes in invoiceAddress and notes state
    setInvoiceAddress(prev => ({ ...prev, notes: '' }));
    setNotes('');
    // Reset multi-product states and clear order summary/cart
    setOrderItems([]); // Leert die Bestellübersicht
    setCurrentProduct(null);
    setCurrentOptions([]);
    setCurrentQuantity(1);
    // Do NOT clear currentPersonalization here!
    // setCurrentPersonalization({ line1: '', line2: '' });
    setCurrentPdfPreview(null);
    fetchAndAutofillCustomerInfo(token, setAddress, setCustomerEmail);
  };

  // Fetch products after login
  React.useEffect(() => {
    if (token) {
      axios.get(`${API}/products`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          // API kann entweder ein Array oder ein Objekt mit products liefern
          const products = Array.isArray(res.data) ? res.data : res.data.products || [];
          setProducts(products);
          if (!Array.isArray(products) || products.length === 0) {
            console.warn('Products API returned empty or invalid data:', res.data);
          }
        })
        .catch(err => {
          setProducts([]);
          if (err.response) {
            console.error('Products API error:', err.response.status, err.response.data);
          } else {
            console.error('Products API error:', err);
          }
          alert('Fehler beim Laden der Produkte. Bitte prüfen Sie Ihre Verbindung oder melden Sie sich erneut an.');
        });
    }
  }, [token]);

  // Fetch customer info after login
  // React.useEffect(() => {
  //   if (token) {
  //     fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
  //       headers: { Authorization: `Bearer ${token}` }
  //     })
  //       .then(res => res.json())
  //       .then(data => {
  //         // lastOrderNumbers direkt aus der Response setzen
  //         if (Array.isArray(data?.last_order_numbers) && data.last_order_numbers.length > 0) {
  //           setLastOrderNumbers([Number(data.last_order_numbers[0]) + 1]);
  //         } else {
  //           setLastOrderNumbers([]);
  //         }
  //         // Adresse setzen
  //         let addr = {};
  //         if (Array.isArray(data?.lieferadressen)) {
  //           addr = data.lieferadressen.find(a => {
  //             const kuerzel = a['ASP.ADR.ADR::Adressart_Kürzel'] || '';
  //             const anschriftwahl = a['ASP.ADR.ADR::Anschriftwahl_STG_Lieferung'] || '';
  //             return kuerzel.includes('L') && String(anschriftwahl).trim() === '1';
  //           }) || {};
  //         } else {
  //           addr = data?.lieferadresse_fields || {};
  //         }
  //         // console.log('Raw Lieferadresse:', addr);
  //         let begr = data?.all_fields?.['Begruessung_STG_Portal'];
  //         if (begr && typeof begr === 'string') {
  //           begr = begr.replace(/\r\n|\r/g, '\n').replace(/<br\s*\/?>/gi, '\n').trim();
  //           setBegruessung(begr);
  //           // console.log('Begrüßung aus FileMaker:', begr);
  //         } else {
  //           setBegruessung('');
  //           // console.log('Begrüßung aus FileMaker: leer');
  //         }
  //         let recid = addr['RecID'] || addr['recid'] || addr['RECID'] || addr['RecordID'] || null;
  //         let institution = addr['ASP.ADR.ADR::Institution'] || '';
  //         let adresszusatz = addr['ASP.ADR.ADR::Adresszusatz'] || '';
  //         let name = addr['ASP.ADR.ADR::Empfänger'] || '';
  //         let street = addr['ASP.ADR.ADR::Straße'] || data?.street || '';
  //         let city = addr['ASP.ADR.ADR::Ort'] || data?.city || '';
  //         let postal_code = addr['ASP.ADR.ADR::PLZ_Straße'] || addr['ASP.ADR.ADR::PLZ der Straße'] || data?.postal_code || '';
  //         // Fallback auf all_fields falls keine passende Lieferadresse gefunden
  //         // if (!institution && data?.all_fields) {
  //         //   const fields = data.all_fields;
  //         //   recid = fields['RecID'] || fields['recid'] || fields['RECID'] || null;
  //         //   institution = fields['ASP.KDN::Institution'] || '';
  //         //   adresszusatz = fields['ASP.KDN::Adresszusatz'] || '';
  //         //   name = fields['ASP.KDN::Name'] || '';
  //         //   street = fields['ASP.KDN::Strasse'] || '';
  //         //   city = fields['ASP.KDN::Ort'] || '';
  //         //   postal_code = fields['ASP.KDN::PLZ'] || '';
  //         // }
  //         setAddress({ institution, adresszusatz, name, street, city, postal_code, recid });
  //         // Rechnungsadresse setzen (analog zur Lieferadresse)
  //         let invoiceAddr = {};
  //         if (Array.isArray(data?.rechnungsadresse_fields)) {
  //           invoiceAddr = data.rechnungsadresse_fields.find(a => {
  //             const kuerzel = a['ASP.ADR.ADR::Adressart_Kürzel'] || '';
  //             const anschriftwahl = a['ASP.ADR.ADR::Anschriftwahl_STG_Rechnung'] || '';
  //             return kuerzel.includes('R') && String(anschriftwahl).trim() === '1';
  //           }) || {};
  //         } else {
  //           invoiceAddr = data?.rechnungsadresse_fields || {};
  //         }
  //         let inv_recid = invoiceAddr['RecID'] || invoiceAddr['recid'] || invoiceAddr['RECID'] || invoiceAddr['RecordID'] || null;
  //         let inv_institution = invoiceAddr['ASP.ADR.ADR::Institution'] || '';
  //         let inv_adresszusatz = invoiceAddr['ASP.ADR.ADR::Adresszusatz'] || '';
  //         let inv_name = invoiceAddr['ASP.ADR.ADR::Empfänger'] || invoiceAddr['ASP.KDN::Name'] || '';
  //         let inv_street = invoiceAddr['ASP.ADR.ADR::Straße'] || invoiceAddr['ASP.KDN::Strasse'] || '';
  //         let inv_city = invoiceAddr['ASP.ADR.ADR::Ort'] || invoiceAddr['ASP.KDN::Ort'] || '';
  //         let inv_postal_code = invoiceAddr['ASP.ADR.ADR::PLZ_Straße'] || invoiceAddr['ASP.ADR.ADR::PLZ der Straße'] || invoiceAddr['ASP.KDN::PLZ'] || '';
  //         setInvoiceAddress({ institution: inv_institution, adresszusatz: inv_adresszusatz, name: inv_name, street: inv_street, city: inv_city, postal_code: inv_postal_code, recid: inv_recid });
  //         // console.log('Full /api/customer-info response:', data);
  //         // console.log('Raw rechnungsadresse_fields:', data.rechnungsadresse_fields);
  //         // E-Mail aus FileMaker übernehmen
  //         let email = data?.email || (data?.all_fields && data.all_fields['ASP.KDN::E-Mail']) || '';
  //         if (email) setCustomerEmail(email);
  //         // Personalisierungsfelder aus SW_Info_Eindrucke übernehmen
  //         // Die Felder heißen: Schwarzwald_Eindruck_Zeile_1 und Schwarzwald_Eindruck_Zeile_2
  //         setPersonalization({
  //           line1: data?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_1'] || '',
  //           line2: data?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_2'] || '',
  //           line1_bold: data?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_1_Bold'] === '1',
  //           line2_bold: data?.all_fields?.['ASP.KDN::Schwarzwald_Eindruck_Zeile_2_Bold'] === '1'
  //         });
  //         // Logo aus FileMaker
  //         const base64 = data?.all_fields?.['ASP.KDN::Schwarzwald_Logo_Base64'];
  //         if (base64 && typeof base64 === 'string' && base64.length > 0) {
  //           setFilemakerLogoBase64(base64);
  //         } else {
  //           setFilemakerLogoBase64(null);
  //         }
  //       });
  //   }
  // }, [token]);
  // (removed old useEffect for customer-info fetch, now handled by customerInfo-based useEffect above)

  // Optional: logout function
  const handleLogout = () => {
    const token = window.sessionStorage.getItem('token');
    if (token) {
      logoutApi(token).catch(() => { }); // Fehler ignorieren, immer lokal ausloggen
    }
    setToken(null);
    window.sessionStorage.removeItem('token');
    // Reset all relevant state
    setSelectedProduct(null);
    setSelectedOptions([]);
    setQuantity(1);
    setPersonalization({ line1: '', line2: '', line1_bold: false, line2_bold: false });
    setPdfPreview(null);
    setCurrentProduct(null);
    setCurrentOptions([]);
    setCurrentQuantity(1);
    setCurrentPersonalization({ line1: '', line2: '', line1_bold: false, line2_bold: false });
    setCurrentPdfPreview(null);
    setProductTab('manuell');
    setOrderComplete(false);
    setOrderDetails(null);
    setOrderItems([]);
    setLogoPreview(null); // Logo-Preview beim Logout zurücksetzen
    setLogoFile(null);
    setStep(-1); // Show login screen after logout
    setPreviousStep(null);
    setCurrentStep(1);
    setLastOrderNumbers([]);
    setFmResult(null);
    setTypewriterPlayed(false);
    window.sessionStorage.removeItem('typewriterPlayed');
  };

  // Handle product selection
  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setQuantity(product.min_quantity || 500);
    setPersonalization({ line1: '', line2: '', line1_bold: false, line2_bold: false });
    setPdfPreview(null);
    setCurrentStep(2);
    // Standard-Optionen: erste Option pro Typ vorauswählen
    const minQty = product.min_quantity || 500;
    if (product && Array.isArray(product.options)) {
      const grouped = product.options.reduce((acc, option) => {
        const type = option.id.split('_')[0];
        if (!acc[type]) acc[type] = [];
        acc[type].push(option);
        return acc;
      }, {});
      const defaultOptions = Object.values(grouped).map(options => options[0]?.id).filter(Boolean);
      setSelectedOptions(defaultOptions);
      setCurrentProduct(product);
      setCurrentOptions(defaultOptions);
      setCurrentQuantity(minQty);
      setCurrentPersonalization({ line1: '', line2: '', line1_bold: false, line2_bold: false });
      setCurrentPdfPreview(null);
    } else {
      setSelectedOptions([]);
      setCurrentProduct(product);
      setCurrentOptions([]);
      setCurrentQuantity(minQty);
      setCurrentPersonalization({ line1: '', line2: '', line1_bold: false, line2_bold: false });
      setCurrentPdfPreview(null);
    }
  };

  // Handle option change
  const handleOptionChange = (type, optionId) => {
    // Only one option per type
    const filtered = selectedOptions.filter(id => !id.startsWith(type + '_'));
    setSelectedOptions([...filtered, optionId]);
  };

  // Produkt zur Bestellung hinzufügen
  const handleAddProductToOrder = () => {
    if (!currentProduct) return;
    setOrderItems([
      ...orderItems,
      {
        product: currentProduct,
        options: currentOptions,
        quantity: currentQuantity,
        personalization: currentPersonalization,
        pdfPreview: currentPdfPreview,
        setAsDefaultLogo // Info pro Produkt speichern, falls relevant
      }
    ]);
    // Debug: Produktobjekt inkl. gmk_param loggen
    // console.log('[DEBUG] Produkt beim Hinzufügen zum Warenkorb:', currentProduct);

    // Reset für neues Produkt
    setCurrentProduct(null);
    setCurrentOptions([]);
    setCurrentQuantity(1);
    setCurrentPersonalization({ line1: '', line2: '', line1_bold: false, line2_bold: false });
    setCurrentPdfPreview(null);
    // Checkbox bleibt default aktiviert
    // Nach Bearbeitung: zum vorherigen Schritt zurückspringen
    if (previousStep !== null) {
      setStep(previousStep);
      setPreviousStep(null);
    }
  };

  // Produkt aus Bestellung entfernen
  const handleRemoveOrderItem = (idx) => {
    const newOrderItems = orderItems.filter((_, i) => i !== idx);
    setOrderItems(newOrderItems);
    // Falls keine Produkte mehr im Warenkorb sind, zurück zu Schritt 1 und nach oben scrollen
    if (newOrderItems.length === 0) {
      setStep(1);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  // Produkt aus Bestellung bearbeiten
  const handleEditOrderItem = (idx) => {
    const item = orderItems[idx];
    // Tab automatisch setzen
    if (typeof item.product.id === 'string' && item.product.id.startsWith('E')) {
      setProductTab('elektronisch');
    } else {
      setProductTab('manuell');
    }
    setCurrentProduct(item.product);
    setCurrentOptions(item.options);
    setCurrentQuantity(item.quantity);
    setCurrentPersonalization(item.personalization);
    setCurrentPdfPreview(item.pdfPreview || null);
    setOrderItems(orderItems.filter((_, i) => i !== idx));
    setPreviousStep(step); // aktuellen Schritt merken
    setStep(1); // Wechsel zur Produktseite für Bearbeitung
    // Nach unten scrollen zum Mengen-/Optionenbereich
    setTimeout(() => {
      const mengeLabel = document.querySelector('label.block.text-sm.font-medium.text-gray-700');
      if (mengeLabel) {
        mengeLabel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  // Handle PDF preview
  const handlePreviewPdf = async () => {
    if (!selectedProduct) return;
    try {
      const res = await axios.post(`${API}/preview-pdf`, {
        product_id: selectedProduct.id,
        personalization,
        token,
        product_ids: orderItems.map(item => item.product?.id) // <--- NEU
      });
      setPdfPreview(res.data.pdf_base64);
    } catch (err) {
      console.error('PDF preview error:', err);
      setPdfPreview(null);
    }
  };

  // Calculate total price
  const calculateTotalPrice = () => {
    if (!selectedProduct) return 0;
    // Größenoptionen
    const sizeOptionIds = ["verarbeitung_small", "verarbeitung_medium", "verarbeitung_large"];
    const selectedSizeOptionId = selectedOptions.find(optId => sizeOptionIds.includes(optId));
    let total = 0;
    if (selectedSizeOptionId) {
      const sizeOption = selectedProduct.options.find(opt => opt.id === selectedSizeOptionId);
      if (sizeOption) {
        const optionQuantity = sizeOption.quantity || 1;
        const optionSets = Math.ceil(quantity / optionQuantity);
        total += sizeOption.price * optionSets;
      }
    } else {
      total += selectedProduct.base_price * quantity;
    }
    // Weitere Optionen
    selectedOptions.forEach(optionId => {
      if (sizeOptionIds.includes(optionId)) return;
      const option = selectedProduct.options.find(opt => opt.id === optionId);
      if (option) {
        const optionQuantity = option.quantity || 1;
        const optionSets = Math.ceil(quantity / optionQuantity);
        total += option.price * optionSets;
      }
    });
    return total;
  };

  // Handle order submit
  const handleSubmitOrder = async (extraFields = {}) => {
    if (orderItems.length === 0 || !customerEmail) return;
    setLoading(true);
    // Ensure personalization is present for each item
    // Nutze exakt das Logo, das auch für die PDF-Vorschau verwendet wurde
    // Prüfe, ob nur neutrale Produkte im Warenkorb sind
    const isNeutralOnly = orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102');
    let neutralLogoBase64 = null;
    if (isNeutralOnly) {
      try {
        const res = await fetch('/images/schwarzwald_logo.png');
        const blob = await res.blob();
        const reader = new window.FileReader();
        const base64Promise = new Promise(resolve => {
          reader.onloadend = () => {
            const result = reader.result;
            const match = result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
            resolve(match ? match[2] : result);
          };
        });
        reader.readAsDataURL(blob);
        neutralLogoBase64 = await base64Promise;
      } catch (e) {
        neutralLogoBase64 = null;
      }
    }
    const products = orderItems.map(item => {
      let pers;
      let logoBase64;
      if (isNeutralOnly) {
        pers = { line1: '', line2: '', line1_bold: false, line2_bold: false, logo_base64: neutralLogoBase64 };
        logoBase64 = neutralLogoBase64;
      } else {
        pers = item.personalization && (item.personalization.line1 || item.personalization.line2)
          ? item.personalization
          : personalization;
        if (logoPreview) {
          const match = logoPreview.match(/^data:([\w\/+.-]+);base64,(.*)$/);
          logoBase64 = match ? match[2] : logoPreview;
        } else if (filemakerLogoBase64) {
          logoBase64 = filemakerLogoBase64;
        }
        pers = { ...pers, logo_base64: logoBase64 };
      }
      return {
        product_id: item.product.id,
        quantity: item.quantity,
        selected_options: item.options,
        personalization: pers,
        gmk_param: item.product.gmk_param || null
      };
    });
    // --- PATCH: Pass full order summary and total price to backend ---
    // Calculate total price for all items
    const sizeOptionIds = ["verarbeitung_small", "verarbeitung_medium", "verarbeitung_large"];
    const order_summary = orderItems.map(item => {
      const product = item.product;
      const quantity = item.quantity;
      // Clean option names for summary
      const selectedOptions = (item.options || []).map(optionId => {
        const opt = product.options.find(o => o.id === optionId);
        return opt ? opt.name.replace(/\s*\(Einheitspreis:[^)]+\)/, '') : optionId;
      });
      let itemTotal = 0;
      // Always add base price using base_price_quantity
      const baseQty = product.base_price_quantity || 1;
      itemTotal += product.base_price * (quantity / baseQty);
      // Add all option prices
      (item.options || []).forEach(optionId => {
        const option = product.options.find(opt => opt.id === optionId);
        if (option) {
          const optionQuantity = option.quantity || 1;
          const optionSets = Math.ceil(quantity / optionQuantity);
          itemTotal += option.price * optionSets;
        }
      });
      // Preise NICHT umrechnen, itemTotal bleibt in Euro
      return {
        product_id: product.id,
        product_name: product.name,
        quantity,
        selected_options: selectedOptions,
        personalization: item.personalization,
        item_total: itemTotal
      };
    });
    const total_price = order_summary.reduce((sum, item) => sum + item.item_total, 0);
    // Nummerierung von/bis für K1/M1-Produkte
    // Berechne nummeriertMenge und endNr analog zu InvoiceAddressForm
    const nummeriertMenge = orderItems
      .filter(item => {
        const id = item?.product?.id || item?.product_id || '';
        return id.startsWith('K1') || id.startsWith('M1');
      })
      .reduce((sum, item) => sum + (item.quantity || 0), 0);
    let nummerierung_von = editableOrderNumber;
    let nummerierung_bis = '';
    if (editableOrderNumber && nummeriertMenge > 0) {
      const start = parseInt(editableOrderNumber, 10);
      if (!isNaN(start)) {
        nummerierung_bis = (start + nummeriertMenge - 1).toString();
      }
    }
    // Patch: auftragsbearbeitung aus extraFields immer direkt ins Payload übernehmen, falls vorhanden
    const payload = {
      products,
      customer_email: customerEmail,
      customer_name: customerInfo && customerInfo.name ? customerInfo.name : '',
      delivery_address: {
        institution: address.institution,
        adresszusatz: address.adresszusatz,
        name: address.name,
        street: address.street,
        city: address.city,
        postal_code: address.postal_code
      },
      notes: invoiceAddress.notes && invoiceAddress.notes.trim().length > 0 ? invoiceAddress.notes : undefined,
      pdf_base64: pdfBase64 || null, // <-- Echtes PDF-Base64 aus Preview-API!
      order_summary,
      total_price,
      nummerierung_von: nummerierung_von || undefined,
      nummerierung_bis: nummerierung_bis || undefined,
      ...(extraFields.auftragsbearbeitung ? { auftragsbearbeitung: extraFields.auftragsbearbeitung } : {}),
      ...extraFields
    };
    // Debug: Logge Order-Payload immer
    // console.log('[DEBUG] Submitting order payload:', payload);
    try {
      const res = await axios.post(`${API}/orders`, payload, {
        headers: { Authorization: token ? `Bearer ${token}` : undefined }
      });
      setOrderDetails(res.data);
      setOrderComplete(true);
      if (res.data && res.data.nummerierung_bis) {
        const nextNumber = String(Number(res.data.nummerierung_bis) + 1);
        setEditableOrderNumber(nextNumber);
        setLastOrderNumbers([Number(nextNumber)]);
      }
      // --- PATCH: Logo-Update nach Bestellung ---
      try {
        let aspIdKdn = null;
        if (token) {
          const resKdn = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
            headers: { Authorization: `Bearer ${token}` }
          });
          const dataKdn = await resKdn.json();
          aspIdKdn = dataKdn?.all_fields?.['ASP::ID.KDN'];
        }
        if (!aspIdKdn) throw new Error('Kundendaten konnten nicht geladen werden.');
        // Immer das aktuellste Logo nehmen: logoPreview bevorzugen
        let logoBase64 = null;
        if (logoPreview) {
          const match = logoPreview.match(/^data:([\w\/+.-]+);base64,(.*)$/);
          logoBase64 = match ? match[2] : logoPreview;
        } else if (personalization.logo_base64) {
          logoBase64 = personalization.logo_base64;
        }
        // if (!logoBase64) throw new Error('Kein Logo zum Speichern gefunden.');
        // Nur Logo-Update, wenn User ein neues Logo hochgeladen hat und Toggle aktiv ist
        if (logoPreview && setAsDefaultLogo) {
          await axios.post(`${API}/update-kdn-logo`, {
            asp_id_kdn: aspIdKdn,
            logo_base64: logoBase64
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
      } catch (err) {
        console.error('Fehler beim Logoupdate im FileMaker:', err?.response?.data || err);
      }
      // --- END PATCH ---
    } catch (err) {
      if (err.response) {
        console.error('Order API error:', err.response.status, err.response.data);
        if (err.response.data && err.response.data.detail) {
          err.response.data.detail.forEach((item, idx) => {
            console.error(`Validation error ${idx + 1}:`, item);
          });
        }
        alert(`Fehler bei der Bestellung (Status ${err.response.status}): ${JSON.stringify(err.response.data)}`);
      } else {
        console.error('Order submit error:', err);
        alert('Fehler bei der Bestellung. Bitte prüfen Sie Ihre Eingaben.');
      }
    }
    setLoading(false);
  };

  // Anzeige steuern: Login, Bestellbestätigung oder Hauptseite
  // Immer Parent-Element für JSX und Footer am Ende
  React.useEffect(() => {
    if (orderComplete) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [orderComplete]);

  // Inactivity overlay rendering (only if token is set)
  if (showInactivityOverlay && token) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col min-h-screen bg-black bg-opacity-20">
        {/* Header ohne Logout und BurgerMenu, zentriert */}
        <header className="bg-white dark:bg-gray-900 shadow-md py-6 sticky top-0 z-20">
          <div className="max-w-5xl mx-auto px-4 flex items-center">
            <div className="flex items-center gap-6 flex-shrink-0">
              <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '48px', width: 'auto' }} />
              <img src="/images/rieco_logo.png" alt="RIECO Logo" style={{ height: '48px', width: 'auto' }} />
              <span className="text-3xl font-bold tracking-tight">
                <span className="font-bold text-[#e30613] dark:text-red-400">{PORTAL_NAME}</span>
                <span className="ml-2 text-[#0a2239] dark:text-white"><br />Bestellportal</span>
              </span>
            </div>
            <div className="flex-1" />
            <div className="flex items-center gap-4 ml-auto">
              {/* Dark Mode Switch */}
              <label className="flex items-center cursor-pointer select-none">
                <span className="mr-2 text-sm text-gray-700 dark:text-gray-200">Dark Mode</span>
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={() => setDarkMode(v => !v)}
                  className="hidden"
                />
                <span className={`w-10 h-6 flex items-center bg-gray-300 dark:bg-gray-600 rounded-full p-1 duration-300 ease-in-out ${darkMode ? 'bg-blue-600' : ''}`}>
                  <span className={`bg-white dark:bg-gray-800 w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${darkMode ? 'translate-x-4' : ''}`}></span>
                </span>
              </label>
            </div>
          </div>
        </header>
        {/* Overlay Content */}
        <div className="flex-1 flex flex-col items-center justify-center">
          <div className="bg-white rounded-xl shadow-xl p-8 flex flex-col items-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Sitzung abgelaufen</h2>
            <p className="text-gray-600 mb-6">Sie wurden wegen Inaktivität automatisch ausgeloggt.</p>
            <button
              onClick={handleInactivityOk}
              className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold"
            >OK</button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!token) {
    return (
      <div className="min-h-screen flex flex-col relative bg-black bg-opacity-20" style={{ overflow: 'hidden' }}>
        {/* Header wie im Inactivity-Overlay, zentriert, jetzt mit Dark-Mode-Toggle */}
        <header className="bg-white dark:bg-gray-900 shadow-md py-6 sticky top-0 z-20">
          <div className="max-w-5xl mx-auto px-4 flex items-center">
            <div className="flex items-center gap-6 flex-shrink-0">
              <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '48px', width: 'auto' }} />
              <img src="/images/rieco_logo.png" alt="RIECO Logo" style={{ height: '48px', width: 'auto' }} />
              <span className="text-3xl font-bold tracking-tight">
                <span className="font-bold text-[#e30613]">{PORTAL_NAME}</span>
                <span className="ml-2 text-[#0a2239] dark:text-white"><br />Bestellportal</span>
              </span>
            </div>
            <div className="flex-1" />
            <div className="flex items-center gap-4 ml-auto">
              {/* Dark Mode Switch */}
              <label className="flex items-center cursor-pointer select-none">
                <span className="mr-2 text-sm text-gray-700 dark:text-gray-200">Dark Mode</span>
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={() => setDarkMode(v => !v)}
                  className="hidden"
                />
                <span className={`w-10 h-6 flex items-center bg-gray-300 dark:bg-gray-600 rounded-full p-1 duration-300 ease-in-out ${darkMode ? 'bg-blue-600' : ''}`}>
                  <span className={`bg-white dark:bg-gray-800 w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${darkMode ? 'translate-x-4' : ''}`}></span>
                </span>
              </label>
            </div>
          </div>
        </header>
        {/* Loginform exakt mittig zwischen Header und Footer, ohne Scrollbalken */}
        <div style={{
          position: 'absolute',
          top: '96px', // header height (py-6 = 1.5rem*2 = 48px + logo = ~48px)
          bottom: '96px', // footer height estimate
          left: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 0,
          height: 'auto',
          overflow: 'visible',
        }}>
          <Login onLogin={handleLogin} loginError={loginError} />
        </div>
        <Footer />
      </div>
    );
  }
  if (step === -1) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#c2e0f7] to-[#7a99b8] dark:from-gray-400 dark:to-gray-900 flex flex-col" style={{ scrollbarGutter: 'stable' }}>
        {/* Header mit Dark Mode Toggle */}
        <header className="bg-white dark:bg-gray-900 shadow-md py-6 sticky top-0 z-20">
          <div className="max-w-5xl mx-auto px-4 flex items-center">
            <div className="flex items-center gap-6 flex-shrink-0">
              {/* Firmenlogos */}
              <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '48px', width: 'auto' }} />
              <img src="/images/rieco_logo.png" alt="RIECO Logo" style={{ height: '48px', width: 'auto' }} />
              <span className="text-3xl font-bold tracking-tight">
                <span className="font-bold text-[#e30613]">{PORTAL_NAME}</span>
                <span className="ml-2 text-[#0a2239] dark:text-white"> <br />Bestellportal</span>
              </span>
            </div>
            <div className="flex-1" />
            <div className="flex items-center gap-4 ml-auto">
              {/* Dark Mode Switch */}
              <label className="flex items-center cursor-pointer select-none">
                <span className="mr-2 text-sm text-gray-700 dark:text-gray-200">Dark Mode</span>
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={() => setDarkMode(v => !v)}
                  className="hidden"
                />
                <span className={`w-10 h-6 flex items-center bg-gray-300 dark:bg-gray-600 rounded-full p-1 duration-300 ease-in-out ${darkMode ? 'bg-blue-600' : ''}`}>
                  <span className={`bg-white dark:bg-gray-800 w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${darkMode ? 'translate-x-4' : ''}`}></span>
                </span>
              </label>
              {token && (
                <button
                  onClick={handleLogout}
                  className="bg-gray-300 text-gray-800 py-2 px-6 rounded-lg hover:bg-gray-400 transition-colors font-semibold"
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        </header>
        <BurgerMenu setStep={setStep} />
        {/* Perfect vertical centering without scrollbars */}
        <div
          style={{
            position: 'absolute',
            top: '96px', // header height (py-6 = 1.5rem*2 = 48px + logo = ~48px)
            bottom: '96px', // footer height estimate
            left: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 0,
            height: 'auto',
            overflow: 'visible',
          }}
        >
          <Startseite
            onStartOrder={() => setStep(1)}
            typewriterPlayed={typewriterPlayed}
            setTypewriterPlayed={setTypewriterPlayed}
            begruessung={begruessung}
          />
        </div>
        <Footer />
      </div>
    );
  }


  // Bestätigungsseite nutzt die Preise aus orderDetails.order_summary und orderDetails.total_price
  if (orderComplete) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#c2e0f7] to-[#7a99b8] dark:from-gray-400 dark:to-gray-900 flex flex-col items-center">
        {/* Header und BurgerMenu wie auf den anderen Seiten */}
        <header className="bg-white dark:bg-gray-900 shadow-md py-6 mb-8 sticky top-0 z-20 w-full">
          <div className="max-w-5xl mx-auto px-4 flex items-center">
            <div className="flex items-center gap-6 flex-shrink-0">
              <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '48px', width: 'auto' }} />
              <img src="/images/rieco_logo.png" alt="RIECO Logo" style={{ height: '48px', width: 'auto' }} />
              <span className="text-3xl font-bold tracking-tight">
                <span className="font-bold text-[#e30613]">{PORTAL_NAME}</span>
                <span className="ml-2 text-[#0a2239] dark:text-white"> <br />Bestellportal</span>
              </span>
            </div>
            <div className="flex-1" />
            <div className="flex items-center gap-4 ml-auto">
              {/* Dark Mode Switch */}
              <label className="flex items-center cursor-pointer select-none">
                <span className="mr-2 text-sm text-gray-700 dark:text-gray-200">Dark Mode</span>
                <input
                  type="checkbox"
                  checked={darkMode}
                  onChange={() => setDarkMode(v => !v)}
                  className="hidden"
                />
                <span className={`w-10 h-6 flex items-center bg-gray-300 dark:bg-gray-600 rounded-full p-1 duration-300 ease-in-out ${darkMode ? 'bg-blue-600' : ''}`}>
                  <span className={`bg-white dark:bg-gray-800 w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${darkMode ? 'translate-x-4' : ''}`}></span>
                </span>
              </label>
              {token && (
                <button
                  onClick={handleLogout}
                  className="bg-gray-300 text-gray-800 py-2 px-6 rounded-lg hover:bg-gray-400 transition-colors font-semibold"
                >
                  Logout
                </button>
              )}
            </div>
          </div>
        </header>
        <BurgerMenu setStep={setStep} />
        <div className="w-full max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 mt-8">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Bestellung bestätigt!</h1>
          <p className="text-gray-600 mb-6">
            Vielen Dank für Ihre Bestellung. Eine Bestätigung wurde an {orderDetails?.customer_email} gesendet.
          </p>
          <div className="bg-gray-50 rounded-lg p-6 mb-6" style={{ minWidth: 700, maxWidth: '100%' }}>
            <h3 className="font-semibold text-gray-800 mb-2">Bestelldetails</h3>
            <p>Bestellnummer: <span className="font-bold">{orderDetails?.id_bst}</span></p>
            <table className="w-full text-left mb-4" style={{ minWidth: 700, maxWidth: '100%' }}>
              <thead>
                <tr className="border-b">
                  <th className="py-2">Produkt</th>
                  <th className="py-2">Menge</th>
                  <th className="py-2">Optionen</th>
                  <th className="py-2">Preis</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails?.order_summary?.map((item, idx) => (
                  <tr key={idx} className="border-b">
                    <td className="py-2" style={{ minWidth: 180 }}>{item.product_name}</td>
                    <td className="py-2" style={{ minWidth: 80 }}>{item.quantity.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</td>
                    <td className="py-2" style={{ minWidth: 180 }}>{Array.isArray(item.selected_options) && item.selected_options.length > 0
                      ? item.selected_options.map(optId => {
                        const product = products.find(p => p.id === item.product_id);
                        const option = product && product.options.find(o => o.id === optId);
                        return option ? option.name.replace(/\s*\(Einheitspreis:[^)]+\)/, '') : optId;
                      }).join(', ')
                      : '–'}</td>
                    <td className="py-2 font-semibold" style={{ minWidth: 80 }}>{formatEuro(item.item_total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p>Gesamt: <span className="font-bold text-green-600">{formatEuro(orderDetails?.total_price || 0)}</span></p>
          </div>
          {/* {orderDetails?.pdf_base64 && (
            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3">Ihre Vorschau</h4>
              <iframe
                src={`data:application/pdf;base64,${orderDetails.pdf_base64}`}
                className="w-full h-96 border rounded-lg"
                title="Order PDF Preview"
              />
            </div>
          )} */}
          {orderDetails?.nummerierung_bis && (
            <div style={{ marginBottom: 18 }}>
              <b>Nummerierung:</b> von <b>{orderDetails.nummerierung_von ? Number(orderDetails.nummerierung_von).toLocaleString('de-DE') : ''}</b> bis <b>{orderDetails.nummerierung_bis ? Number(orderDetails.nummerierung_bis).toLocaleString('de-DE') : ''}</b>
            </div>
          )}
          {orderDetails?.jpg_base64 && (
            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3">Ihre Vorschau</h4>
              <img
                src={`data:image/jpeg;base64,${orderDetails.jpg_base64}`}
                alt="PDF Vorschau als Bild"
                className="w-full h-96 object-contain border rounded-lg"
                style={{ maxWidth: 593, maxHeight: 384 }}
              />
              {/* <a
                href={`data:application/pdf;base64,${orderDetails.pdf_base64}`}
                download="Bestellung.pdf"
                className="block mt-2 text-blue-600 underline"
              >
                PDF herunterladen
              </a> */}
            </div>
          )}
          <button
            onClick={handleNewOrder}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold mr-4"
          >
            Neue Bestellung aufgeben
          </button>
          <button
            onClick={handleLogout}
            className="bg-gray-300 text-gray-800 px-8 py-3 rounded-lg hover:bg-gray-400 transition-colors font-semibold"
          >
            Logout
          </button>
        </div>
        <div className="pb-24" />
        <Footer />
      </div>
    );
  }

  // Hauptseite
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#c2e0f7] to-[#7a99b8] dark:from-gray-400 dark:to-gray-900 py-0 pb-24" style={{ scrollbarGutter: 'stable' }}>
      {/* Globales Modal für Produktbild-Vorschau */}
      {productImageModal.open && (
        <div
          // className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          // className="fixed left-0 right-0 bottom-0 bg-black bg-opacity-70 flex items-center justify-center z-40"
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setProductImageModal({ open: false, src: '', alt: '' })}
          style={{ top: '96px' }} // Passe 96px auf die tatsächliche Headerhöhe an
        >
          <img
            src={productImageModal.src}
            alt={productImageModal.alt || 'Produktbild Vorschau'}
            style={{
              maxWidth: '800px',
              maxHeight: '650px',
              marginTop: '-96px',
              width: 'auto',
              height: 'auto',
              boxShadow: '0 4px 32px rgba(0,0,0,0.25)',
              border: '4px solid #fff',
              background: '#fff',
              objectFit: 'contain',
            }}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
      <BurgerMenu setStep={setStep} />
      {/* Header */}
      <header className="bg-white dark:bg-gray-900 shadow-md py-6 mb-8 sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-4 flex items-center">
          <div className="flex items-center gap-6 flex-shrink-0">
            {/* Firmenlogos */}
            <img src="/images/schwarzwald_logo.png" alt="Schwarzwald Tourismus Logo" style={{ height: '48px', width: 'auto' }} />
            <img src="/images/rieco_logo.png" alt="RIECO Logo" style={{ height: '48px', width: 'auto' }} />
            <span className="text-3xl font-bold tracking-tight">
              <span className="font-bold text-[#e30613]">{PORTAL_NAME}</span>
              <span className="ml-2 text-[#0a2239] dark:text-white"> <br />Bestellportal</span>
            </span>
          </div>
          <div className="flex-1" />
          <div className="flex items-center gap-4 ml-auto">
            {/* Dark Mode Switch */}
            <label className="flex items-center cursor-pointer select-none">
              <span className="mr-2 text-sm text-gray-700 dark:text-gray-200">Dark Mode</span>
              <input
                type="checkbox"
                checked={darkMode}
                onChange={() => setDarkMode(v => !v)}
                className="hidden"
              />
              <span className={`w-10 h-6 flex items-center bg-gray-300 dark:bg-gray-600 rounded-full p-1 duration-300 ease-in-out ${darkMode ? 'bg-blue-600' : ''}`}>
                <span className={`bg-white dark:bg-gray-800 w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${darkMode ? 'translate-x-4' : ''}`}></span>
              </span>
            </label>
            {token && (
              <button
                onClick={handleLogout}
                className="bg-gray-300 text-gray-800 py-2 px-6 rounded-lg hover:bg-gray-400 transition-colors font-semibold"
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </header>
      {/* Hauptinhalt */}
      {/* Schritt 1: Produkt-Auswahl und Hinzufügen */}
      {/* Blinker-Hinweis für Bestellannahme-Zeiträume */}
      {(() => {
        const now = new Date();
        // const now = new Date('2025-01-16');
        // const now = new Date('2024-01-01');
        const year = now.getFullYear();
        const month = now.getMonth() + 1; // JS: 0-basiert
        const day = now.getDate();
        let bestellJahr = year;
        if (month < 4 || (month === 3 && day <= 31)) {
          bestellJahr = year - 1;
        }
        // 16.09. bis 31.03. Folgejahr
        // const isWinter = (month > 9 || (month === 9 && day >= 16)) || (month < 4 || (month === 3 && day <= 31));
        const isWinter = (month > 9 || (month === 10 && day >= 1)) || (month < 3 || (month === 2 && day <= 28));
        // 16.04. bis 31.07.
        const isSommer = (month > 4 && month < 8) || (month === 4 && day >= 1) || (month === 7 && day <= 31);
        if (isWinter) {
          const nextApril = month >= 9 ? year + 1 : year;
          return (
            <div className="w-full flex justify-center mb-8">
              <div className="max-w-5xl w-full mx-auto px-4">
                <span style={{
                  color: 'red',
                  fontWeight: 'bold',
                  animation: 'blinker 1.75s linear infinite',
                  fontSize: '1.3rem',
                  textAlign: 'center',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '8px',
                  display: 'block',
                  width: '100%',
                  padding: '16px 0',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
                }}>
                  Die Bestellannahme für die aktuelle Sammelbestellung ist am 01.10.{bestellJahr} abgelaufen.<br />Falls Sie eine Bestellung aufgeben möchten,<br />gilt diese für den nächsten Bestellzyklus ab dem 01.04.{nextApril}.
                </span>
                <style>{`@keyframes blinker { 50% { opacity: 0.2; }}`}</style>
              </div>
            </div>
          );
        }
        if (isSommer) {
          const nextSeptember = month >= 4 ? year : year;
          return (
            <div className="w-full flex justify-center mb-8">
              <div className="max-w-5xl w-full mx-auto px-4">
                <span style={{
                  color: 'red',
                  fontWeight: 'bold',
                  animation: 'blinker 1.75s linear infinite',
                  fontSize: '1.3rem',
                  textAlign: 'center',
                  background: 'rgba(255,255,255,0.8)',
                  borderRadius: '8px',
                  display: 'block',
                  width: '100%',
                  padding: '16px 0',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
                }}>
                  Die Bestellannahme für die aktuelle Sammelbestellung ist am 01.04.{bestellJahr} abgelaufen.<br />Falls Sie eine Bestellung aufgeben möchten,<br />gilt diese für den nächsten Bestellzyklus ab dem 01.09.{nextSeptember}.
                </span>
                <style>{`@keyframes blinker { 50% { opacity: 0.2; }}`}</style>
              </div>
            </div>
          );
        }
        return null;
      })()}
      {step === 1 && (
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row gap-8">
          <div className="flex-1 space-y-8">
            <InfoBox />
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Produkte</h2>
                <button
                  className="ml-4 px-2 py-1 bg-gray-100 border border-gray-300 rounded text-xs text-gray-700 hover:bg-blue-100 hover:text-blue-700 transition-colors shadow"
                  style={{ zIndex: 10 }}
                  title="Produkte neu laden"
                  onClick={reloadProducts}
                  disabled={loading}
                >🔄 Produkte neu laden</button>
              </div>
              {/* Tabs für Produktarten */}
              <div className="flex gap-4 mb-6">
                {manuelleProdukte.length > 0 && (
                  <button
                    className={`px-4 py-2 rounded-lg font-semibold transition-colors ${productTab === 'manuell' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                    onClick={() => handleTabChange('manuell')}
                  >Manuelle Meldescheine</button>
                )}
                {elektronischeProdukte.length > 0 && (
                  <button
                    className={`px-4 py-2 rounded-lg font-semibold transition-colors ${productTab === 'elektronisch' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                    onClick={() => handleTabChange('elektronisch')}
                  >Elektronische Meldescheine</button>
                )}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {tabProdukte.length === 0 ? (
                  <div className="col-span-2 text-gray-400 text-center py-12 text-lg">
                    Keine Produkte gefunden.<br />Bitte setzen Sie sich mit uns in Verbindung, damit wir Ihnen die Produkte freischalten können.
                  </div>
                ) : (
                  tabProdukte.map(product => (
                    <ProductCard
                      key={product.id}
                      product={product}
                      onSelect={p => {
                        setCurrentProduct(p);
                        setCurrentQuantity(p.min_quantity || 500);
                      }}
                      isSelected={currentProduct && currentProduct.id === product.id}
                      disabled={false}
                      onImageClick={handleProductImageClick}
                    />
                  ))
                )}
              </div>
            </div>
            {currentProduct && (
              <OptionSelector
                options={currentProduct.options}
                selectedOptions={currentOptions}
                onOptionChange={(type, optionId) => {
                  const filtered = currentOptions.filter(id => !id.startsWith(type + '_'));
                  setCurrentOptions([...filtered, optionId]);
                }}
                quantity={currentQuantity}
              />
            )}
            {currentProduct && (
              <div className="bg-white p-6 rounded-xl shadow-md pb-8">
                <label className="block text-sm font-medium text-gray-700 mb-2">Menge</label>
                <div className="flex items-center gap-4">
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9.]+"
                    value={currentQuantity.toLocaleString('de-DE')}
                    onFocus={e => e.target.select()}
                    onChange={e => {
                      // Tausenderpunkte entfernen, nur Ziffern übernehmen
                      let raw = e.target.value.replace(/\./g, '');
                      // Nur Ziffern zulassen
                      if (!/^\d*$/.test(raw)) return;
                      // Temporär als Zahl speichern, aber noch nicht validieren
                      setCurrentQuantity(raw === '' ? '' : Number(raw));
                    }}
                    onBlur={e => {
                      let raw = e.target.value.replace(/\./g, '');
                      let val = Number(raw);
                      const min = currentProduct.min_quantity || 500;
                      if (isNaN(val) || val < min) val = min;
                      // Nur 500er Schritte erlauben
                      if (val % 500 !== 0) val = Math.round(val / 500) * 500;
                      setCurrentQuantity(val);
                    }}
                    className="w-40 px-4 py-2 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right"
                    placeholder={String(currentProduct.min_quantity || 500)}
                  />
                  <div className="text-xs text-gray-500">
                    Mindestmenge: <span className="font-semibold">{(currentProduct.min_quantity || 500).toLocaleString('de-DE')}</span><br />
                    Schrittweite: <span className="font-semibold">500</span>
                  </div>
                </div>
              </div>
            )}
            {currentProduct && (
              <button
                onClick={handleAddProductToOrder}
                className="w-full bg-green-600 text-white py-4 px-6 rounded-lg hover:bg-green-700 transition-colors font-semibold mt-4"
              >
                Produkt zur Bestellung hinzufügen
              </button>
            )}
            {orderItems.length > 0 && (
              <button
                onClick={() => setStep(2)}
                className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg hover:bg-blue-700 transition-colors font-bold text-lg mt-4"
              >
                Weiter zur Personalisierung
              </button>
            )}
          </div>
          <div className="w-full md:w-96">
            <div className="sticky top-24 z-10">
              {/* Bestellübersicht immer anzeigen, auch wenn leer */}
              {/* <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} pdfPreview={step === 3 ? pdfPreview : null} personalization={step === 3 ? personalization : null} showPreviewModal={step === 3} setStep={setStep} /> */}
              <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} pdfPreview={step === 3 ? pdfPreview : null} personalization={null} showPreviewModal={step === 3} setStep={setStep} />
            </div>
          </div>
        </div>
      )}
      {/* Schritt 2: Personalisierung für die gesamte Bestellung */}
      {step === 2 && (
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row gap-8">
          <div className="flex-1 space-y-8">
            <div className="bg-blue-50 border-l-4 border-blue-400 rounded-xl shadow p-4 mb-8">
              <h2 className="text-lg font-bold mb-2 text-blue-700">Hinweis zur Personalisierung</h2>
              <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                <li>Geben Sie hier die gewünschten Personalisierungsdaten für Ihre Druckprodukte ein.</li>
                <li>Die Angaben werden auf allen Produkten übernommen.</li>
                <li>Sie können die Vorschau unten prüfen und bei Bedarf die Eingaben anpassen.</li>
                <li>Mit <span className="font-semibold text-blue-700">Weiter zur Lieferadresse</span> gelangen Sie zum nächsten Schritt.</li>
              </ul>
            </div>
            {(() => {
              let aspIdKdnSafe = null;
              if (customerInfo && customerInfo.all_fields && typeof customerInfo.all_fields['ASP::ID.KDN'] !== 'undefined') {
                aspIdKdnSafe = customerInfo.all_fields['ASP::ID.KDN'];
              }
              return (
                <PersonalizationForm
                  personalization={personalization}
                  onChange={setPersonalization}
                  previewLogoBase64={filemakerLogoBase64}
                  orderItems={orderItems}
                  customerInfo={customerInfo}
                  aspIdKdn={aspIdKdnSafe}
                />
              );
            })()}
            {/* Logo-Upload-Feld und Vorschau */}
            {/* Logo-Upload nur anzeigen, wenn nicht ausschließlich neutrale Produkte */}
            {!(orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102')) && (
              <div className="bg-white p-6 rounded-xl shadow-md mb-8">
                <h4 className="font-semibold text-gray-800 mb-3">Logo-Upload <span className="text-xs text-gray-500">(optional)</span></h4>
                <div className="flex flex-col md:flex-row gap-6 items-center">
                  <div className="flex flex-col items-center justify-center w-32 min-h-[110px] bg-gray-50 rounded-lg border border-gray-200 shadow-sm p-2">
                    {logoUploading ? (
                      <div className="h-16 w-16 flex items-center justify-center">
                        <svg className="animate-spin h-10 w-10 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                        </svg>
                      </div>
                    ) : logoFile ? (
                      <div className="relative w-full flex flex-col items-center">
                        <img
                          src={
                            (logoFile.type === 'application/pdf' || logoFile.type === 'application/postscript')
                              ? (pdfIconPreview ? `data:image/jpeg;base64,${pdfIconPreview}` : '/pdf-icon.svg')
                              : logoPreview
                          }
                          alt="Logo Vorschau"
                          className="h-16 w-auto rounded border border-gray-300 shadow cursor-zoom-in mb-1 bg-white"
                          onClick={() => setLogoModalOpen('icon')}
                          style={{ cursor: 'zoom-in' }}
                        />
                        {(logoFile.type === 'application/pdf' || logoFile.type === 'application/postscript') && !pdfIconPreview && !logoUploading && (
                          <span className="text-xs text-red-500 mt-1">Keine Vorschau generiert</span>
                        )}
                        <span className="text-xs text-gray-600 mt-1 max-w-[120px] truncate">{logoFile.name}</span>
                        <button
                          type="button"
                          className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs shadow-lg"
                          onClick={e => {
                            setLogoFile(null);
                            setLogoPreview(null);
                            setPdfIconPreview(null);
                            setPersonalization(p => ({ ...p, logo_base64: null }));
                            const input = e.target.closest('.relative').parentNode.parentNode.querySelector('input[type="file"]');
                            if (input) input.value = "";
                            setPreviewLoading(true);
                            setPdfPreview(null);
                            setPdfBase64(null);
                            // NEU: Vorschau-Logik wie beim Step-Wechsel
                            const isNeutralOnly = orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102');
                            let payload;
                            if (isNeutralOnly) {
                              // Neutrales Produkt: leere Textzeilen und neutrales Logo
                              // Logo als Base64 aus /images/schwarzwald_logo.png holen
                              fetch('/images/schwarzwald_logo.png')
                                .then(res => res.blob())
                                .then(blob => {
                                  const reader = new window.FileReader();
                                  reader.onloadend = () => {
                                    const result = reader.result;
                                    const match = result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                                    const neutralLogoBase64 = match ? match[2] : result;
                                    payload = {
                                      line1: '',
                                      line2: '',
                                      line1_bold: false,
                                      line2_bold: false,
                                      logo_base64: neutralLogoBase64,
                                      product_ids: orderItems.map(item => item.product?.id)
                                    };
                                    axios.post(`${API}/preview-pdf`, payload)
                                      .then(res => {
                                        setPdfPreview(res.data.jpg_base64);
                                        setPdfBase64(res.data.pdf_base64 || null);
                                        setPreviewLoading(false);
                                      })
                                      .catch(() => {
                                        setPdfPreview(null);
                                        setPdfBase64(null);
                                        setPreviewLoading(false);
                                      });
                                  };
                                  reader.readAsDataURL(blob);
                                });
                            } else {
                              // Normale Produkte: Personalisierung und Logo wie gehabt
                              payload = { ...personalization };
                              if (filemakerLogoBase64) {
                                payload.logo_base64 = filemakerLogoBase64;
                              } else {
                                payload.logo_base64 = null;
                              }
                              payload.product_ids = orderItems.map(item => item.product?.id);
                              axios.post(`${API}/preview-pdf`, payload)
                                .then(res => {
                                  setPdfPreview(res.data.jpg_base64);
                                  setPdfBase64(res.data.pdf_base64 || null);
                                  setPreviewLoading(false);
                                })
                                .catch(() => {
                                  setPdfPreview(null);
                                  setPdfBase64(null);
                                  setPreviewLoading(false);
                                });
                            }
                          }}
                          title="Logo entfernen"
                        >
                          &times;
                        </button>
                        <button
                          type="button"
                          className="mt-2 px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 text-xs"
                          onClick={() => {
                            // NEU: Vorschau-Logik wie beim Step-Wechsel und Logo entfernen
                            const isNeutralOnly = orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102');
                            if (isNeutralOnly) {
                              setLogoUploading(true);
                              // Neutrales Produkt: leere Textzeilen und neutrales Logo
                              fetch('/images/schwarzwald_logo.png')
                                .then(res => res.blob())
                                .then(blob => {
                                  const reader = new window.FileReader();
                                  reader.onloadend = () => {
                                    const result = reader.result;
                                    const match = result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                                    const neutralLogoBase64 = match ? match[2] : result;
                                    const payload = {
                                      line1: '',
                                      line2: '',
                                      line1_bold: false,
                                      line2_bold: false,
                                      logo_base64: neutralLogoBase64,
                                      product_ids: orderItems.map(item => item.product?.id)
                                    };
                                    axios.post(`${API}/preview-pdf`, payload)
                                      .then(res => {
                                        setPdfPreview(res.data.jpg_base64);
                                        setPdfBase64(res.data.pdf_base64 || null);
                                        setPreviewLoading(false);
                                      })
                                      .catch(() => {
                                        setPdfPreview(null);
                                        setPdfBase64(null);
                                        setPreviewLoading(false);
                                      });
                                    setLogoUploading(false);
                                  };
                                  reader.readAsDataURL(blob);
                                });
                            } else if (logoFile && (logoFile.type === 'application/pdf' || logoFile.type === 'application/postscript')) {
                              setLogoUploading(true);
                              const reader = new window.FileReader();
                              reader.onload = ev => {
                                const match = ev.target.result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                                const base64 = match ? match[2] : ev.target.result;
                                axios.post(`${API}/preview-pdf`, {
                                  logo_base64: base64,
                                  preview_icon: true,
                                  product_ids: orderItems.map(item => item.product?.id),
                                }).then(res => {
                                  if (res.data && res.data.icon_base64) {
                                    setPdfIconPreview(res.data.icon_base64);
                                  } else {
                                    setPdfIconPreview(null);
                                  }
                                  setLogoUploading(false);
                                }).catch(err => {
                                  setPdfIconPreview(null);
                                  setLogoUploading(false);
                                });
                              };
                              reader.readAsDataURL(logoFile);
                            } else if (logoFile) {
                              setLogoUploading(true);
                              const reader = new window.FileReader();
                              reader.onload = ev => {
                                setLogoPreview(ev.target.result);
                                setPreviewLoading(true);
                                const payload = { ...personalization };
                                const match = ev.target.result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                                payload.logo_base64 = match ? match[2] : ev.target.result;
                                payload.product_ids = orderItems.map(item => item.product?.id);
                                axios.post(`${API}/preview-pdf`, payload)
                                  .then(res => {
                                    setPdfPreview(res.data.jpg_base64);
                                    setPdfBase64(res.data.pdf_base64 || null);
                                    setPreviewLoading(false);
                                  })
                                  .catch(() => {
                                    setPdfPreview(null);
                                    setPdfBase64(null);
                                    setPreviewLoading(false);
                                  });
                                setLogoUploading(false);
                              };
                              reader.readAsDataURL(logoFile);
                            }
                          }}
                          disabled={logoUploading}
                        >Vorschau neu laden</button>
                      </div>
                    ) : (
                      <span className="text-xs text-gray-400">Noch kein Logo ausgewählt</span>
                    )}
                  </div>
                  <div className="flex-1 flex flex-col gap-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Datei auswählen:</label>
                    <input
                      type="file"
                      accept="image/*,.pdf,.eps"
                      onChange={e => {
                        setLogoError('');
                        const file = e.target.files[0];
                        if (!file) return;
                        // Nur Bilder prüfen
                        if (file.type.startsWith('image/')) {
                          const img = new window.Image();
                          img.onload = () => {
                            if (img.width > MAX_LOGO_WIDTH || img.height > MAX_LOGO_HEIGHT) {
                              setLogoError(`Das Bild ist zu groß (${img.width}x${img.height} Pixel). Maximal erlaubt sind ${MAX_LOGO_WIDTH}x${MAX_LOGO_HEIGHT} Pixel.`);
                              setLogoUploading(false);
                              setLogoFile(null);
                              setLogoPreview(null);
                              setPdfIconPreview(null);
                              setPersonalization(p => ({ ...p, logo_base64: null }));
                              let input = null;
                              const relative = e.target.closest('.relative');
                              if (relative) {
                                const parent1 = relative.parentNode;
                                if (parent1) {
                                  const parent2 = parent1.parentNode;
                                  if (parent2) {
                                    input = parent2.querySelector('input[type="file"]');
                                  }
                                }
                              }
                              if (input) {
                                input.value = "";
                              }
                              setPreviewLoading(true);
                              setPdfPreview(null);
                              setPdfBase64(null);
                              // NEU: Vorschau-Logik wie beim Step-Wechsel
                              const isNeutralOnly = orderItems.length > 0 && orderItems.every(item => item.product.id === 'K2-100002' || item.product.id === 'M2-100102');
                              let payload;
                              if (isNeutralOnly) {
                                // Neutrales Produkt: leere Textzeilen und neutrales Logo
                                // Logo als Base64 aus /images/schwarzwald_logo.png holen
                                fetch('/images/schwarzwald_logo.png')
                                  .then(res => res.blob())
                                  .then(blob => {
                                    const reader = new window.FileReader();
                                    reader.onloadend = () => {
                                      const result = reader.result;
                                      const match = result.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                                      const neutralLogoBase64 = match ? match[2] : result;
                                      payload = {
                                        line1: '',
                                        line2: '',
                                        line1_bold: false,
                                        line2_bold: false,
                                        logo_base64: neutralLogoBase64,
                                        product_ids: orderItems.map(item => item.product?.id)
                                      };
                                      axios.post(`${API}/preview-pdf`, payload)
                                        .then(res => {
                                          setPdfPreview(res.data.jpg_base64);
                                          setPdfBase64(res.data.pdf_base64 || null);
                                          setPreviewLoading(false);
                                        })
                                        .catch(() => {
                                          setPdfPreview(null);
                                          setPdfBase64(null);
                                          setPreviewLoading(false);
                                        });
                                    };
                                    reader.readAsDataURL(blob);
                                  });
                              } else {
                                // Normale Produkte: Personalisierung und Logo wie gehabt
                                payload = { ...personalization };
                                if (filemakerLogoBase64) {
                                  payload.logo_base64 = filemakerLogoBase64;
                                } else {
                                  payload.logo_base64 = null;
                                }
                                payload.product_ids = orderItems.map(item => item.product?.id);
                                axios.post(`${API}/preview-pdf`, payload)
                                  .then(res => {
                                    setPdfPreview(res.data.jpg_base64);
                                    setPdfBase64(res.data.pdf_base64 || null);
                                    setPreviewLoading(false);
                                  })
                                  .catch(() => {
                                    setPdfPreview(null);
                                    setPdfBase64(null);
                                    setPreviewLoading(false);
                                  });
                              }

                              return;
                            }
                            // Bild ist ok, Upload wie gehabt
                            setLogoUploading(true);
                            setLogoFile(file);
                            const formData = new FormData();
                            formData.append('logo', file);
                            axios.post(`${API}/upload-logo`, formData, {
                              headers: { 'Content-Type': 'multipart/form-data' }
                            }).then(res => {
                              if (res.data && res.data.logo_base64) {
                                setPersonalization(p => ({ ...p, logo_base64: res.data.logo_base64 }));
                                if (file.type === 'application/pdf' || file.type === 'application/postscript') {
                                  axios.post(`${API}/preview-pdf`, {
                                    logo_base64: res.data.logo_base64,
                                    preview_icon: true
                                  }).then(res2 => {
                                    if (res2.data && res2.data.icon_base64) {
                                      setPdfIconPreview(res2.data.icon_base64);
                                      setLogoPreview(`data:image/jpeg;base64,${res2.data.icon_base64}`);
                                    } else {
                                      setPdfIconPreview(null);
                                      setLogoPreview(null);
                                    }
                                    setLogoUploading(false);
                                  }).catch(() => {
                                    setPdfIconPreview(null);
                                    setLogoPreview(null);
                                    setLogoUploading(false);
                                  });
                                } else {
                                  setLogoPreview(`data:image/png;base64,${res.data.logo_base64}`);
                                  setLogoUploading(false);
                                }
                                setPreviewLoading(true);
                                setPdfPreview(null);
                                setPdfBase64(null);
                                const payload = { ...personalization, logo_base64: res.data.logo_base64 };
                                axios.post(`${API}/preview-pdf`, payload)
                                  .then(res2 => {
                                    setPdfPreview(res2.data.jpg_base64);
                                    setPdfBase64(res2.data.pdf_base64 || null);
                                    setPreviewLoading(false);
                                  })
                                  .catch(() => {
                                    setPdfPreview(null);
                                    setPdfBase64(null);
                                    setPreviewLoading(false);
                                  });
                              } else {
                                setPersonalization(p => ({ ...p, logo_base64: null }));
                                setLogoPreview(null);
                                setLogoUploading(false);
                              }
                            }).catch(error => {
                              setPersonalization(p => ({ ...p, logo_base64: null }));
                              setLogoPreview(null);
                              setLogoUploading(false);
                              // Fehlertext aus Backend anzeigen, falls vorhanden
                              if (error.response && error.response.data && error.response.data.detail) {
                                setLogoError(error.response.data.detail);
                              } else {
                                setLogoError('Fehler beim Upload. Bitte versuchen Sie es erneut.');
                              }
                            });
                          };
                          img.onerror = () => {
                            setLogoError('Das Bild konnte nicht geladen werden.');
                            setLogoUploading(false);
                            setLogoFile(null);
                          };
                          const reader = new FileReader();
                          reader.onload = e2 => { img.src = e2.target.result; };
                          reader.readAsDataURL(file);
                        } else {
                          // PDF/EPS wie gehabt hochladen
                          setLogoUploading(true);
                          setLogoFile(file);
                          const formData = new FormData();
                          formData.append('logo', file);
                          axios.post(`${API}/upload-logo`, formData, {
                            headers: { 'Content-Type': 'multipart/form-data' }
                          }).then(res => {
                            if (res.data && res.data.logo_base64) {
                              setPersonalization(p => ({ ...p, logo_base64: res.data.logo_base64 }));
                              if (file.type === 'application/pdf' || file.type === 'application/postscript') {
                                axios.post(`${API}/preview-pdf`, {
                                  logo_base64: res.data.logo_base64,
                                  preview_icon: true
                                }).then(res2 => {
                                  if (res2.data && res2.data.icon_base64) {
                                    setPdfIconPreview(res2.data.icon_base64);
                                    setLogoPreview(`data:image/jpeg;base64,${res2.data.icon_base64}`);
                                  } else {
                                    setPdfIconPreview(null);
                                    setLogoPreview(null);
                                  }
                                  setLogoUploading(false);
                                }).catch(() => {
                                  setPdfIconPreview(null);
                                  setLogoPreview(null);
                                  setLogoUploading(false);
                                });
                              } else {
                                setLogoPreview(`data:image/png;base64,${res.data.logo_base64}`);
                                setLogoUploading(false);
                              }
                              setPreviewLoading(true);
                              setPdfPreview(null);
                              setPdfBase64(null);
                              const payload = { ...personalization, logo_base64: res.data.logo_base64 };
                              axios.post(`${API}/preview-pdf`, payload)
                                .then(res2 => {
                                  setPdfPreview(res2.data.jpg_base64);
                                  setPdfBase64(res2.data.pdf_base64 || null);
                                  setPreviewLoading(false);
                                })
                                .catch(() => {
                                  setPdfPreview(null);
                                  setPdfBase64(null);
                                  setPreviewLoading(false);
                                });
                            } else {
                              setPersonalization(p => ({ ...p, logo_base64: null }));
                              setLogoPreview(null);
                              setLogoUploading(false);
                            }
                          }).catch(() => {
                            setPersonalization(p => ({ ...p, logo_base64: null }));
                            setLogoPreview(null);
                            setLogoUploading(false);
                          });
                        }
                      }}
                      className="block border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      disabled={logoUploading}
                    />
                    {logoError && (
                      <div className="text-red-500 text-xs mt-2">{logoError}</div>
                    )}
                    {/* <button
                        type="button"
                        className={`mt-3 px-3 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-semibold transition-colors ${!logoFile || logoUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={!logoFile || logoUploading}
                        onClick={async () => {
                          if (!logoFile || logoUploading) return;
                          try {
                            setLogoUploading(true);
                            // Prefer logoPreview (Base64) if available, else personalization.logo_base64
                            let logoBase64 = null;
                            if (logoPreview) {
                              const match = logoPreview.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                              logoBase64 = match ? match[2] : logoPreview;
                            } else if (personalization.logo_base64) {
                              logoBase64 = personalization.logo_base64;
                            }
                            if (!logoBase64) {
                              console.log('Kein Logo zum Übertragen gefunden.');
                              setLogoUploading(false);
                              return;
                            }
                            const token = window.sessionStorage.getItem('token');
                            let aspIdKdn = null;
                            if (token) {
                              const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/customer-info', {
                                headers: { Authorization: `Bearer ${token}` }
                              });
                              const data = await res.json();
                              aspIdKdn = data?.all_fields?.['ASP::ID.KDN'];
                            }
                            if (!aspIdKdn) {
                              console.log('Kundendaten konnten nicht geladen werden.');
                              setLogoUploading(false);
                              return;
                            }
                            // Call backend to update logo in FileMaker
                            const updateRes = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/update-kdn-logo', {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${token}`
                              },
                              body: JSON.stringify({ asp_id_kdn: aspIdKdn, logo_base64: logoBase64 })
                            });
                            if (!updateRes.ok) {
                              const errData = await updateRes.json();
                              throw new Error(errData?.detail || 'Unbekannter Fehler beim Logoaustausch');
                            }
                            console.log('Logo wurde erfolgreich in der Datenbank aktualisiert.');
                          } catch (err) {
                            alert('Fehler beim Logoaustausch: ' + (err?.response?.data?.detail || err.message));
                          } finally {
                            setLogoUploading(false);
                          }
                        }}
                      >Logoaustausch im FileMaker anstoßen</button> */}
                    <label className="flex items-center gap-3 text-sm font-medium text-gray-700 mt-2 select-none">
                      <span>Als Standardlogo für zukünftige Bestellungen speichern</span>
                      <Tooltip text="Wenn sie diese Option aktivieren wird das Logo für zukünftige Bestellungen gespeichert.">
                        <button
                          type="button"
                          className={`relative inline-flex h-6 w-11 rounded-full transition-colors focus:outline-none ${!logoFile ? 'bg-gray-300 cursor-not-allowed' : setAsDefaultLogo ? 'bg-blue-600' : 'bg-gray-400'}`}
                          aria-pressed={setAsDefaultLogo}
                          disabled={!logoFile}
                          onClick={() => logoFile && setSetAsDefaultLogo(v => !v)}
                          style={{ minWidth: 44 }}
                        >
                          <span
                            className={`inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ${setAsDefaultLogo ? 'translate-x-5' : 'translate-x-0'}`}
                            style={{ marginTop: 2, marginLeft: 2 }}
                          />
                        </button>
                      </Tooltip>
                    </label>
                  </div>
                </div>
              </div>
            )}
            {/* Bild-Vorschau mit Modal */}
            <div className="bg-white p-6 rounded-xl shadow-md pb-8">
              <h4 className="font-semibold text-gray-800 mb-3">Bild-Vorschau</h4>
              {previewLoading && (
                <div className="flex items-center justify-center w-full h-96">
                  <svg className="animate-spin h-12 w-12 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                </div>
              )}
              {pdfPreview && !previewLoading && (
                <>
                  <img
                    src={`data:image/jpeg;base64,${pdfPreview}`}
                    className="border-2 border-grey-300"
                    style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                    // style={{ width: '241px', height: '156px', objectFit: 'contain' }}
                    alt="PDF Vorschau als Bild"
                    // src={`data:image/jpeg;base64,${pdfPreview}`}
                    // className="w-full h-96 object-contain border rounded-lg cursor-zoom-in"
                    // alt="PDF Vorschau als Bild"
                    onClick={() => setLogoModalOpen('pdf')}
                  />
                  <button
                    type="button"
                    className="mt-3 px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 text-xs"
                    onClick={() => {
                      setPreviewLoading(true);
                      setPdfPreview(null);
                      setPdfBase64(null);
                      const payload = { ...personalization };
                      payload.product_ids = orderItems.map(item => item.product?.id);
                      if (logoPreview) {
                        const match = logoPreview.match(/^data:([\w\/+.-]+);base64,(.*)$/);
                        payload.logo_base64 = match ? match[2] : logoPreview;
                      } else if (filemakerLogoBase64) {
                        payload.logo_base64 = filemakerLogoBase64;
                      } else {
                        payload.logo_base64 = null;
                      }
                      axios.post(`${API}/preview-pdf`, payload)
                        .then(res => {
                          setPdfPreview(res.data.jpg_base64);
                          setPdfBase64(res.data.pdf_base64 || null);
                          setPreviewLoading(false);
                        })
                        .catch(() => {
                          setPdfPreview(null);
                          setPdfBase64(null);
                          setPreviewLoading(false);
                        });
                    }}
                    disabled={previewLoading}
                  >Vorschau neu laden</button>
                </>
              )}
              {/* Modal für PDF-Vorschau */}
              {logoModalOpen === 'pdf' && pdfPreview && (
                <div
                  className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                  onClick={() => setLogoModalOpen(false)}
                >
                  <img
                    src={`data:image/jpeg;base64,${pdfPreview}`}
                    // style={{ width: '241px', height: '156px', objectFit: 'contain' }}
                    style={{
                      maxWidth: '800px',
                      maxHeight: '650px',
                      width: 'auto',
                      height: 'auto',
                      // borderRadius: '16px',
                      boxShadow: '0 4px 32px rgba(0,0,0,0.25)',
                      border: '4px solid #fff',
                      background: '#fff',
                      objectFit: 'contain'
                    }}
                    alt="PDF Vorschau als Bild"
                    // src={`data:image/jpeg;base64,${pdfPreview}`}
                    // alt="PDF Vorschau groß"
                    // className="max-h-[80vh] max-w-[90vw] rounded shadow-lg border-4 border-white"
                    onClick={e => e.stopPropagation()}
                  />
                </div>
              )}
              {/* Modal für Logo-Icon-Vorschau */}
              {logoModalOpen === 'icon' && logoFile && (
                <div
                  className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                  onClick={() => setLogoModalOpen(false)}
                >
                  <img
                    src={
                      (logoFile.type === 'application/pdf' || logoFile.type === 'application/postscript')
                        ? (pdfIconPreview ? `data:image/jpeg;base64,${pdfIconPreview}` : '/pdf-icon.svg')
                        : logoPreview
                    }
                    alt="Logo Vorschau groß"
                    className="max-h-[80vh] max-w-[90vw] rounded shadow-lg border-4 border-white"
                    onClick={e => e.stopPropagation()}
                  />
                </div>
              )}
            </div>
            <button
              onClick={() => setStep(3)}
              className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg hover:bg-blue-700 transition-colors font-bold text-lg mt-4"
              disabled={previewLoading || !pdfPreview}
            >
              {previewLoading ? 'Vorschau wird geladen...' : 'Weiter zur Lieferadresse'}
            </button>
            <button
              onClick={() => setStep(1)}
              className="w-full bg-gray-300 text-gray-800 py-2 px-6 rounded-lg hover:bg-gray-400 transition-colors font-semibold mt-2"
            >
              Zurück zur Produkt-Auswahl
            </button>
          </div>
          <div className="w-full md:w-96">
            <div className="sticky top-24 z-10">
              {/* <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} personalization={step === 3 ? personalization : null} pdfPreview={null} showPreviewModal={false} setStep={setStep} step={step} /> */}
              <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} personalization={null} pdfPreview={null} showPreviewModal={false} setStep={setStep} step={step} />
            </div>
          </div>
        </div>
      )}
      {/* Schritt 3: Liefer-Adresse*/}
      {step === 3 && (
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row gap-8">
          <div className="flex-1 space-y-8">
            {/* <AddressForm address={address} onChange={setAddress} customerEmail={customerEmail} onEmailChange={setCustomerEmail} /> */}
            <AddressForm address={address} onChange={setAddress} />
            {/* <div className="bg-white p-6 rounded-xl shadow-md">
              <label className="block text-sm font-medium text-gray-700 mb-2">Notiz (optional)</label>
              <textarea
                value={notes}
                onChange={e => setNotes(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows={2}
                placeholder="Ihre Nachricht oder Hinweise zur Bestellung"
              />
            </div> */}
            {(() => {
              // Required fields for Lieferadresse
              const requiredFields = [
                { key: 'institution', label: 'Firmenname Zeile 1' },
                { key: 'street', label: 'Straße' },
                { key: 'postal_code', label: 'PLZ' },
                { key: 'city', label: 'Ort' },
              ];
              const missing = requiredFields.filter(f => !address[f.key] || address[f.key].trim() === '').map(f => f.label);
              return (
                <div className="flex w-full">
                  {missing.length > 0 ? (
                    <Tooltip
                      text={
                        'Bitte folgende Felder ausfüllen, diese werden mindestens benötigt:' +
                        (missing.length > 0 ? '\n' + missing.map(f => '- ' + f).join('\n') : '')
                      }
                      position="top"
                      minWidth="180px"
                      className="flex-1 w-full"
                    >
                      <button
                        className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg hover:bg-blue-700 transition-colors font-bold text-lg mt-4 disabled:opacity-60 disabled:cursor-not-allowed"
                        disabled
                      >
                        Weiter zur Rechnungsadresse
                      </button>
                    </Tooltip>
                  ) : (
                    <button
                      onClick={() => setStep(4)}
                      className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg hover:bg-blue-700 transition-colors font-bold text-lg mt-4 disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                      Weiter zur Rechnungsadresse
                    </button>
                  )}
                </div>
              );
            })()}
            {/* <button
              onClick={handleSubmitOrder}
              className="w-full bg-green-600 text-white py-4 px-6 rounded-lg hover:bg-green-700 transition-colors font-bold text-lg mt-4"
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin h-5 w-5 text-white mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Bestellung wird gesendet...
                </span>
              ) : 'Bestellung abschließen'}
            </button> */}
            <button
              onClick={() => setStep(2)}
              className="w-full bg-gray-300 text-gray-800 py-2 px-6 rounded-lg hover:bg-gray-400 transition-colors font-semibold mt-2"
            >
              Zurück zur Personalisierung
            </button>
          </div>
          <div className="w-full md:w-96">
            <div className="sticky top-24 z-10">
              {/* <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} personalization={personalization} pdfPreview={pdfPreview} showPreviewModal={true} setStep={setStep} step={step} /> */}
              <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} personalization={null} pdfPreview={pdfPreview} showPreviewModal={true} setStep={setStep} step={step} />
            </div>
          </div>
        </div>
      )}
      {/* Schritt 4: Rechnungsadresse */}
      {step === 4 && (
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row gap-8">
          <div className="flex-1 space-y-8">
            <InvoiceAddressForm
              invoiceAddress={invoiceAddress}
              onChange={updated => {
                setInvoiceAddress(updated);
                if ('notes' in updated) setNotes(updated.notes);
              }}
              customerEmail={customerEmail}
              onEmailChange={setCustomerEmail}
              emailError={emailError}
              onEmailBlur={() => {
                if (customerEmail && !isValidEmail(customerEmail)) {
                  setEmailError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
                } else {
                  setEmailError('');
                }
              }}
              orderItems={orderItems}
              lastOrderNumbers={lastOrderNumbers || []}
              editableOrderNumber={editableOrderNumber}
              setEditableOrderNumber={setEditableOrderNumber}
            />
            {/* Sync invoice address with backend */}
            {/* {useInvoiceAddressSync(invoiceAddress, customerEmail)} */}
            <div className="flex w-full">
              {getInvoiceAddressMissingFields().length > 0 ? (
                <Tooltip
                  text={
                    'Bitte folgende Felder ausfüllen:' +
                    (getInvoiceAddressMissingFields().length > 0
                      ? '\n- ' + getInvoiceAddressMissingFields().join('\n- ')
                      : '')
                  }
                  position="top"
                  minWidth="180px"
                  className="flex-1 w-full"
                >
                  <button
                    className="w-full bg-green-600 text-white py-4 px-6 rounded-lg hover:bg-green-700 transition-colors font-bold text-lg mt-4 disabled:opacity-60 disabled:cursor-not-allowed"
                    disabled
                  >
                    Bestellung abschließen
                  </button>
                </Tooltip>
              ) : (
                <button
                  onClick={() => {
                    if (!isValidEmail(customerEmail)) {
                      setEmailError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
                      return;
                    }
                    setEmailError('');
                    handleCreateFilemaker();
                    // handleSubmitOrder();
                  }}
                  className="w-full bg-green-600 text-white py-4 px-6 rounded-lg hover:bg-green-700 transition-colors font-bold text-lg mt-4 disabled:opacity-60 disabled:cursor-not-allowed"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="flex items-center justify-center">
                      <svg className="animate-spin h-5 w-5 text-white mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                      </svg>
                      Bestellung wird erstellt und gesendet...
                    </span>
                  ) : 'Bestellung abschließen'}
                </button>
              )}
            </div>
            {/* <button
              onClick={handleCreateFilemaker}
              className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold text-base shadow"
              disabled={fmLoading}
            >
              {fmLoading ? 'FileMaker-Test läuft...' : 'Test: FileMaker-Bestellung anlegen'}
            </button>
            {fmResult && (
              <pre className="mt-4 text-xs bg-gray-100 rounded p-2 max-w-md overflow-x-auto text-left">{JSON.stringify(fmResult, null, 2)}</pre>
            )} */}
            <button
              onClick={() => setStep(3)}
              className="w-full bg-gray-300 text-gray-800 py-2 px-6 rounded-lg hover:bg-gray-400 transition-colors font-semibold mt-2"
            >
              Zurück zur Lieferadresse
            </button>
          </div>
          <div className="w-full md:w-96">
            <div className="sticky top-24 z-10">
              {/* <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} personalization={personalization} pdfPreview={pdfPreview} showPreviewModal={true} setStep={setStep} step={step} /> */}
              <MultiOrderSummary orderItems={orderItems} onRemove={handleRemoveOrderItem} onEdit={handleEditOrderItem} personalization={null} pdfPreview={pdfPreview} showPreviewModal={true} setStep={setStep} step={step} />
            </div>
          </div>
        </div>
      )}
      {/* Bestellhistorie Seite: Am Ende, ohne andere Portal-Logik zu entfernen */}
      {step === 'order-history' && (
        (!customerInfo || !token)
          ? <div className="p-8 text-center text-gray-600 text-lg">Lade Kundendaten oder bitte einloggen...</div>
          : <OrderHistory user={customerInfo} token={token} />
      )}
      <Footer />
    </div>
  );
}
export default App;
